(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4441],{

/***/ 25069:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports._ = void 0;
var use_localstorage_1 = __webpack_require__(755);
Object.defineProperty(exports, "_", ({ enumerable: true, get: function () { return use_localstorage_1.useLocalStorage; } }));
var local_storage_events_1 = __webpack_require__(30606);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return local_storage_events_1.writeStorage; } });
Object.defineProperty(exports, "DC", ({ enumerable: true, get: function () { return local_storage_events_1.deleteFromStorage; } }));
__webpack_unused_export__ = use_localstorage_1.useLocalStorage;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 97517:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isBrowser = void 0;
exports.isBrowser = function () {
    return typeof window !== 'undefined' && typeof window.document !== 'undefined';
};
//# sourceMappingURL=is-browser.js.map

/***/ }),

/***/ 30606:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.deleteFromStorage = exports.writeStorage = exports.isTypeOfLocalStorageChanged = exports.LOCAL_STORAGE_CHANGE_EVENT_NAME = void 0;
var storage_1 = __webpack_require__(41721);
var is_browser_1 = __webpack_require__(97517);
exports.LOCAL_STORAGE_CHANGE_EVENT_NAME = 'onLocalStorageChange';
/**
 * CustomEvent polyfill derived from: https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
 */
(function () {
    if (!is_browser_1.isBrowser()) {
        return;
    }
    if (typeof __webpack_require__.g.window.CustomEvent === 'function') {
        return;
    }
    function CustomEvent(typeArg, params) {
        var _a, _b;
        if (params === void 0) { params = { bubbles: false, cancelable: false }; }
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(typeArg, (_a = params === null || params === void 0 ? void 0 : params.bubbles) !== null && _a !== void 0 ? _a : false, (_b = params === null || params === void 0 ? void 0 : params.cancelable) !== null && _b !== void 0 ? _b : false, params === null || params === void 0 ? void 0 : params.detail);
        return evt;
    }
    window.CustomEvent = CustomEvent;
})();
/**
 * Checks if the event that is passed in is the same type as LocalStorageChanged.
 *
 * @export
 * @template TValue
 * @param {*} evt the object you wish to assert as a onLocalStorageChange event.
 * @returns {evt is LOCAL_STORAGE_CHANGE_EVENT_NAME} if true, evt is asserted to be onLocalStorageChange.
 */
function isTypeOfLocalStorageChanged(evt) {
    return !!evt && evt.type === exports.LOCAL_STORAGE_CHANGE_EVENT_NAME;
}
exports.isTypeOfLocalStorageChanged = isTypeOfLocalStorageChanged;
/**
 * Use this instead of directly using localStorage.setItem
 * in order to correctly send events within the same window.
 *
 * @example
 * ```js
 * writeStorage('hello', JSON.stringify({ name: 'world' }));
 * const { name } = JSON.parse(localStorage.getItem('hello'));
 * ```
 *
 * @export
 * @param {string} key The key to write to in the localStorage.
 * @param {string} value The value to write to in the localStorage.
 */
function writeStorage(key, value) {
    if (!is_browser_1.isBrowser()) {
        return;
    }
    try {
        storage_1.storage.setItem(key, typeof value === 'object' ? JSON.stringify(value) : "" + value);
        window.dispatchEvent(new CustomEvent(exports.LOCAL_STORAGE_CHANGE_EVENT_NAME, {
            detail: { key: key, value: value },
        }));
    }
    catch (err) {
        if (err instanceof TypeError && err.message.includes('circular structure')) {
            throw new TypeError('The object that was given to the writeStorage function has circular references.\n' +
                'For more information, check here: ' +
                'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value');
        }
        throw err;
    }
}
exports.writeStorage = writeStorage;
/**
 * Use this function to delete a value from localStorage.
 *
 * After calling this function, the localStorage value will be null.
 *
 * @example
 * ```js
 * const user = { name: 'John', email: 'John@fakemail.com' };
 *
 * // Add a user to your localStorage
 * writeStorage('user', JSON.stringify(user));
 *
 * // This will also trigger an update to the state of your component
 * deleteFromStorage('user');
 *
 * localStorage.getItem('user') === null // ✔ This is now null
 * ```
 *
 * @export
 * @param {string} key The key of the item you wish to delete from localStorage.
 */
function deleteFromStorage(key) {
    if (!is_browser_1.isBrowser()) {
        return;
    }
    storage_1.storage.removeItem(key);
    window.dispatchEvent(new CustomEvent(exports.LOCAL_STORAGE_CHANGE_EVENT_NAME, {
        detail: { key: key, value: null },
    }));
}
exports.deleteFromStorage = deleteFromStorage;
//# sourceMappingURL=local-storage-events.js.map

/***/ }),

/***/ 41721:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.storage = exports.MemoryStorageProxy = exports.LocalStorageProxy = exports.localStorageAvailable = void 0;
var is_browser_1 = __webpack_require__(97517);
/**
 * Test if localStorage API is available
 * From https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#Feature-detecting_localStorage
 * @returns {boolean}
 */
function localStorageAvailable() {
    try {
        var x = '@rehooks/local-storage:' + new Date().toISOString();
        localStorage.setItem(x, x);
        localStorage.removeItem(x);
        return true;
    }
    catch (e) {
        return is_browser_1.isBrowser() && e instanceof DOMException && (
        // everything except Firefox
        e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            // acknowledge QuotaExceededError only if there's something already stored
            (localStorage && localStorage.length !== 0);
    }
}
exports.localStorageAvailable = localStorageAvailable;
var LocalStorageProxy = /** @class */ (function () {
    function LocalStorageProxy() {
    }
    LocalStorageProxy.prototype.getItem = function (key) {
        return localStorage.getItem(key);
    };
    LocalStorageProxy.prototype.setItem = function (key, value) {
        localStorage.setItem(key, value);
    };
    LocalStorageProxy.prototype.removeItem = function (key) {
        localStorage.removeItem(key);
    };
    return LocalStorageProxy;
}());
exports.LocalStorageProxy = LocalStorageProxy;
var MemoryStorageProxy = /** @class */ (function () {
    function MemoryStorageProxy() {
        this._memoryStorage = new Map();
    }
    MemoryStorageProxy.prototype.getItem = function (key) {
        var _a;
        return (_a = this._memoryStorage.get(key)) !== null && _a !== void 0 ? _a : null;
    };
    MemoryStorageProxy.prototype.setItem = function (key, value) {
        this._memoryStorage.set(key, value);
    };
    MemoryStorageProxy.prototype.removeItem = function (key) {
        this._memoryStorage.delete(key);
    };
    return MemoryStorageProxy;
}());
exports.MemoryStorageProxy = MemoryStorageProxy;
var proxyStorageFrom = function (isAvailable) { return isAvailable
    ? new LocalStorageProxy()
    : new MemoryStorageProxy(); };
exports.storage = proxyStorageFrom(localStorageAvailable());
//# sourceMappingURL=storage.js.map

/***/ }),

/***/ 755:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalStorage = void 0;
var local_storage_events_1 = __webpack_require__(30606);
var is_browser_1 = __webpack_require__(97517);
var storage_1 = __webpack_require__(41721);
var react_1 = __webpack_require__(52983);
/**
 * This exists for trying to serialize the value back to JSON.
 * If it cannot serialize it, then it was a string value given.
 *
 * @param value the value you wish to try to parse
 */
function tryParse(value) {
    try {
        return JSON.parse(value);
    }
    catch (_a) {
        return value;
    }
}
function useLocalStorage(key, defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    var _a = react_1.useState(storage_1.storage.getItem(key) === null
        ? defaultValue
        : tryParse(storage_1.storage.getItem(key))), localState = _a[0], updateLocalState = _a[1];
    var onLocalStorageChange = react_1.useCallback(function (event) {
        // An event value can be of TValue when `localStorage.setItem` is called, or null when
        // `localStorage.removeItem` is called.
        if (local_storage_events_1.isTypeOfLocalStorageChanged(event)) {
            if (event.detail.key === key) {
                updateLocalState(event.detail.value);
            }
        }
        else {
            if (event.key === key) {
                updateLocalState(event.newValue === null ? null : tryParse(event.newValue));
            }
        }
    }, [updateLocalState, key]);
    react_1.useEffect(function () {
        if (!is_browser_1.isBrowser()) {
            return;
        }
        // The custom storage event allows us to update our component
        // when a change occurs in localStorage outside of our component
        var listener = function (e) {
            onLocalStorageChange(e);
        };
        window.addEventListener(local_storage_events_1.LOCAL_STORAGE_CHANGE_EVENT_NAME, listener);
        // The storage event only works in the context of other documents (eg. other browser tabs)
        window.addEventListener('storage', listener);
        // Write default value to the local storage if there currently isn't any value there.
        // Don't however write a defaultValue that is null otherwise it'll trigger infinite updates.
        if (storage_1.storage.getItem(key) === null && defaultValue !== null) {
            local_storage_events_1.writeStorage(key, defaultValue);
        }
        return function () {
            window.removeEventListener(local_storage_events_1.LOCAL_STORAGE_CHANGE_EVENT_NAME, listener);
            window.removeEventListener('storage', listener);
        };
    }, [key, defaultValue, onLocalStorageChange]);
    var writeState = react_1.useCallback(function (value) { return local_storage_events_1.writeStorage(key, value); }, [key]);
    var deleteState = react_1.useCallback(function () { return local_storage_events_1.deleteFromStorage(key); }, [key]);
    var state = localState !== null && localState !== void 0 ? localState : defaultValue;
    return [state, writeState, deleteState];
}
exports.useLocalStorage = useLocalStorage;
//# sourceMappingURL=use-localstorage.js.map

/***/ }),

/***/ 93262:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
     true ? factory(exports, __webpack_require__(79519)) :
    0;
})(this, (function (exports, fetch) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var fetch__default = /*#__PURE__*/_interopDefaultLegacy(fetch);

    class DataValueBase {
        constructor(type, value) {
            this.type = type;
            this.value = value;
        }
    }
    class StringDataValue extends DataValueBase {
        constructor(value) {
            super('String', value);
            this.isCollection = false;
        }
    }
    class StringCollectionDataValue extends DataValueBase {
        constructor(value) {
            super('StringList', {
                $type: 'System.Collections.Generic.List`1[[System.String, System.Private.CoreLib]], System.Private.CoreLib',
                $values: value,
            });
            this.isCollection = true;
        }
    }
    class MultilingualCollectionDataValue extends DataValueBase {
        constructor(values) {
            super('MultilingualCollection', {
                $type: 'System.Collections.Generic.List`1[[Relewise.Client.DataTypes.Multilingual, Relewise.Client]], System.Private.CoreLib',
                $values: values.map(x => ({ values: x.values, language: { value: x.language } })),
            });
            this.isCollection = true;
        }
    }
    class NumberDataValue extends DataValueBase {
        constructor(value) {
            super('Double', value);
            this.isCollection = false;
        }
    }
    class DoubleCollectionDataValue extends DataValueBase {
        constructor(value) {
            super('DoubleList', {
                $type: 'System.Collections.Generic.List`1[[System.Double, System.Private.CoreLib]], System.Private.CoreLib',
                $values: value,
            });
            this.isCollection = true;
        }
    }
    class BooleanDataValue extends DataValueBase {
        constructor(value) {
            super('Boolean', value);
            this.isCollection = false;
        }
    }
    class BooleanCollectionDataValue extends DataValueBase {
        constructor(value) {
            super('BooleanList', {
                $type: 'System.Collections.Generic.List`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib',
                $values: value,
            });
            this.isCollection = true;
        }
    }
    class MultiCurrencyDataValue extends DataValueBase {
        constructor(values) {
            super('MultiCurrency', {
                $type: 'Relewise.Client.DataTypes.MultiCurrency, Relewise.Client',
                values: values.map(x => ({ amount: x.amount, currency: { value: x.currency } })),
            });
            this.isCollection = false;
        }
    }
    class MultilingualDataValue extends DataValueBase {
        constructor(values) {
            super('Multilingual', {
                $type: 'Relewise.Client.DataTypes.Multilingual, Relewise.Client',
                values: values.map(x => ({ text: x.value, language: { value: x.language } })),
            });
            this.isCollection = false;
        }
    }
    class ObjectDataValue extends DataValueBase {
        constructor(dataObject) {
            super('Object', {
                $type: 'Relewise.Client.DataTypes.DataObject, Relewise.Client',
                data: dataObject,
            });
            this.isCollection = false;
        }
    }
    class ObjectCollectionDataValue extends DataValueBase {
        constructor(dataObjects) {
            super('ObjectList', {
                $type: 'System.Collections.Generic.List`1[[Relewise.Client.DataTypes.DataObject, Relewise.Client]], System.Private.CoreLib',
                $values: dataObjects.map(x => ({ $type: 'Relewise.Client.DataTypes.DataObject, Relewise.Client', data: x })),
            });
            this.isCollection = true;
        }
    }

    class DataObjectFilterConditionBuilder {
        constructor() {
            this.conditions = [];
        }
        addContainsCondition(key, value, mode = 'All', objectPath, negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Filters.DataObjects.Conditions.ObjectValueContainsCondition, Relewise.Client',
                key: key,
                value: value,
                objectPath: objectPath,
                mode: mode,
                negated: negated,
            };
            this.conditions.push(condition);
            return this;
        }
        addEqualsCondition(key, value, objectPath, negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Filters.DataObjects.Conditions.ObjectValueEqualsCondition, Relewise.Client',
                value: value,
                objectPath: objectPath,
                negated: negated,
                key: key,
            };
            this.conditions.push(condition);
            return this;
        }
        addInRangeCondition(key, range, objectPath, negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Filters.DataObjects.Conditions.ObjectValueInRangeCondition, Relewise.Client',
                range: range,
                key: key,
                objectPath: objectPath,
                negated: negated,
            };
            this.conditions.push(condition);
            return this;
        }
        addGreaterThanCondition(key, value, objectPath, negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Filters.DataObjects.Conditions.ObjectValueGreaterThanCondition, Relewise.Client',
                value: value,
                negated: negated,
                key: key,
                objectPath: objectPath,
            };
            this.conditions.push(condition);
            return this;
        }
        addLessThanCondition(key, value, objectPath, negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Filters.DataObjects.Conditions.ObjectValueLessThanCondition, Relewise.Client',
                value: value,
                negated: negated,
                key: key,
                objectPath: objectPath,
            };
            this.conditions.push(condition);
            return this;
        }
        addMinByCondition(key, objectPath, negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Filters.DataObjects.Conditions.ObjectValueMinByCondition, Relewise.Client',
                negated: negated,
                key: key,
                objectPath: objectPath,
            };
            this.conditions.push(condition);
            return this;
        }
        addMaxByCondition(key, objectPath, negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Filters.DataObjects.Conditions.ObjectValueMaxByCondition, Relewise.Client',
                negated: negated,
                key: key,
                objectPath: objectPath,
            };
            this.conditions.push(condition);
            return this;
        }
        build() {
            return this.conditions.length === 0
                ? null
                : this.conditions;
        }
    }

    class ConditionBuilder {
        constructor() {
            this.conditions = [];
        }
        addContainsCondition(value, valueCollectionEvaluationMode = 'All', negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Conditions.ContainsCondition, Relewise.Client',
                value: value,
                valueCollectionEvaluationMode: valueCollectionEvaluationMode,
                negated: negated,
            };
            this.conditions.push(condition);
            return this;
        }
        addDistinctCondition(numberOfOccurrencesAllowedWithTheSameValue, negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Conditions.DistinctCondition, Relewise.Client',
                numberOfOccurrencesAllowedWithTheSameValue: numberOfOccurrencesAllowedWithTheSameValue,
                negated: negated,
            };
            this.conditions.push(condition);
            return this;
        }
        addEqualsCondition(value, negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Conditions.EqualsCondition, Relewise.Client',
                value: value,
                negated: negated,
            };
            this.conditions.push(condition);
            return this;
        }
        addGreaterThanCondition(value, negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Conditions.GreaterThanCondition, Relewise.Client',
                value: value,
                negated: negated,
            };
            this.conditions.push(condition);
            return this;
        }
        addLessThanCondition(value, negated = false) {
            const condition = {
                $type: 'Relewise.Client.Requests.Conditions.LessThanCondition, Relewise.Client',
                value: value,
                negated: negated,
            };
            this.conditions.push(condition);
            return this;
        }
        addDataObjectCondition(conditions, skip, take, negated = false) {
            const conditionsBuilder = new DataObjectFilterConditionBuilder();
            conditions(conditionsBuilder);
            const condition = {
                $type: 'Relewise.Client.Requests.Conditions.ContainsCondition, Relewise.Client',
                objectFilter: {
                    conditions: conditionsBuilder.build(),
                    skip: skip,
                    take: take,
                },
                valueCollectionEvaluationMode: 'All',
                negated: negated,
            };
            this.conditions.push(condition);
            return this;
        }
        build() {
            return this.conditions.length === 0
                ? null
                : { items: this.conditions };
        }
    }

    class FilterBuilder {
        constructor() {
            this.filters = [];
        }
        /**
         * Adds a product assortment filter to the request
         * @param assortmentIds
         * @param negated
         */
        addProductAssortmentFilter(assortmentIds, negated = false) {
            const assortments = Array.isArray(assortmentIds)
                ? assortmentIds
                : [assortmentIds];
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductAssortmentFilter, Relewise.Client',
                assortments: assortments,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a variant assortment filter to the request
         * @param assortmentIds
         * @param negated
         */
        addVariantAssortmentFilter(assortmentIds, negated = false) {
            const assortments = Array.isArray(assortmentIds)
                ? assortmentIds
                : [assortmentIds];
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.VariantAssortmentFilter, Relewise.Client',
                assortments: assortments,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a brand assortment filter to the request
         * @param assortmentIds
         * @param negated
         */
        addBrandAssortmentFilter(assortmentIds, negated = false) {
            const assortments = Array.isArray(assortmentIds)
                ? assortmentIds
                : [assortmentIds];
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.BrandAssortmentFilter, Relewise.Client',
                assortments: assortments,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a content category assortment filter to the request
         * @param assortmentIds
         * @param negated
         */
        addContentCategoryAssortmentFilter(assortmentIds, negated = false) {
            const assortments = Array.isArray(assortmentIds)
                ? assortmentIds
                : [assortmentIds];
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ContentCategoryAssortmentFilter, Relewise.Client',
                assortments: assortments,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a content category assortment filter to the request
         * @param assortmentIds
         * @param negated
         */
        addProductCategoryAssortmentFilter(assortmentIds, negated = false) {
            const assortments = Array.isArray(assortmentIds)
                ? assortmentIds
                : [assortmentIds];
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductCategoryAssortmentFilter, Relewise.Client',
                assortments: assortments,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return products within the specificed categories
         * @param evaluationScope
         * @param categoryIds
         * @param negated
         */
        addProductCategoryIdFilter(evaluationScope, categoryIds, negated = false) {
            const ids = Array.isArray(categoryIds)
                ? categoryIds
                : [categoryIds];
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductCategoryIdFilter, Relewise.Client',
                evaluationScope: evaluationScope,
                categoryIds: ids,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return contents within the specificed categories
         * @param evaluationScope
         * @param categoryIds
         * @param negated
         */
        addContentCategoryIdFilter(evaluationScope, categoryIds, negated = false) {
            const ids = Array.isArray(categoryIds)
                ? categoryIds
                : [categoryIds];
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ContentCategoryIdFilter, Relewise.Client',
                evaluationScope: evaluationScope,
                categoryIds: ids,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return the specificied products
         * @param productIds
         * @param negated
         */
        addProductIdFilter(productIds, negated = false) {
            const ids = Array.isArray(productIds)
                ? productIds
                : [productIds];
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductIdFilter, Relewise.Client',
                productIds: ids,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return the specificied variants
         * @param variantIds
         * @param negated
         */
        addVariantIdFilter(variantIds, negated = false) {
            const ids = Array.isArray(variantIds)
                ? variantIds
                : [variantIds];
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.VariantIdFilter, Relewise.Client',
                variantIds: ids,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return the specificied brands
         * @param brandIds
         * @param negated
         */
        addBrandIdFilter(brandIds, negated = false) {
            const ids = Array.isArray(brandIds)
                ? brandIds
                : [brandIds];
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.BrandIdFilter, Relewise.Client',
                brandIds: ids,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return the specificied contents
         * @param contentIds
         * @param negated
         */
        addContentIdFilter(contentIds, negated = false) {
            const ids = Array.isArray(contentIds)
                ? contentIds
                : [contentIds];
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ContentIdFilter, Relewise.Client',
                contentIds: ids,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a range filter to the request ensuring the product has a certain range of variants
         * @param lowerBound
         * @param upperBound
         * @param negated
         */
        addProductHasVariantsFilter(lowerBound, upperBound, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductHasVariantsFilter, Relewise.Client',
                numberOfVariants: {
                    lowerBoundInclusive: lowerBound,
                    upperBoundInclusive: upperBound,
                },
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return products purchased since a certain point in time
         * @param sinceUtc
         * @param negated
         */
        addProductRecentlyPurchasedByUserFilter(sinceUtc, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductRecentlyPurchasedByUserFilter, Relewise.Client',
                sinceUtc: sinceUtc,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return products viewed since a certain point in time
         * @param sinceUtc
         * @param negated
         */
        addProductRecentlyViewedByUserFilter(sinceUtc, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductRecentlyViewedByUserFilter, Relewise.Client',
                sinceUtc: sinceUtc,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return products within a certain SalesPrice-range
         * @param lowerBound
         * @param upperBound
         * @param negated
         */
        addProductSalesPriceFilter(lowerBound, upperBound, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductSalesPriceFilter, Relewise.Client',
                range: {
                    lowerBoundInclusive: lowerBound,
                    upperBoundInclusive: upperBound,
                },
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return products within a certain ListPice-range
         * @param lowerBound
         * @param upperBound
         * @param negated
         */
        addProductListPriceFilter(lowerBound, upperBound, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductListPriceFilter, Relewise.Client',
                range: {
                    lowerBoundInclusive: lowerBound,
                    upperBoundInclusive: upperBound,
                },
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return variants within a certain SalesPrice-range
         * @param lowerBound
         * @param upperBound
         * @param negated
         */
        addVariantSalesPriceFilter(lowerBound, upperBound, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.VariantSalesPriceFilter, Relewise.Client',
                range: {
                    lowerBoundInclusive: lowerBound,
                    upperBoundInclusive: upperBound,
                },
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return variants within a certain ListPice-range
         * @param lowerBound
         * @param upperBound
         * @param negated
         */
        addVariantListPriceFilter(lowerBound, upperBound, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.VariantListPriceFilter, Relewise.Client',
                range: {
                    lowerBoundInclusive: lowerBound,
                    upperBoundInclusive: upperBound,
                },
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Filters the request to only return variants with a certain specification
         * @param key
         * @param equalTo
         * @param filterOutIfKeyIsNotFound controls if variants with or without the key should be returned
         * @param negated
         */
        addVariantSpecificationFilter(key, equalTo, filterOutIfKeyIsNotFound = true, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.VariantSpecificationFilter, Relewise.Client',
                key: key,
                equalTo: equalTo,
                filterOutIfKeyIsNotFound: filterOutIfKeyIsNotFound,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        and(filterBuilder, negated = false) {
            const builder = new FilterBuilder();
            filterBuilder(builder);
            const filters = builder.build();
            if (filters === null || filters.items === undefined || filters.items === null || filters.items.length <= 0) {
                throw new Error('And-filters must contain atleast 1 filter');
            }
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.AndFilter, Relewise.Client',
                filters: filters.items,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        or(filterBuilder, negated = false) {
            const builder = new FilterBuilder();
            filterBuilder(builder);
            const filters = builder.build();
            if (filters === null || filters.items === undefined || filters.items === null || filters.items.length <= 0) {
                throw new Error('Or-filters must contain atleast 1 filter');
            }
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.OrFilter, Relewise.Client',
                filters: filters.items,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a product data filter to the request
         * @param key
         * @param conditionBuilder
         * @param mustMatchAllConditions
         * @param filterOutIfKeyIsNotFound
         * @param negated
         */
        addProductDataFilter(key, conditionBuilder, mustMatchAllConditions = true, filterOutIfKeyIsNotFound = true, negated = false) {
            const builder = new ConditionBuilder();
            conditionBuilder(builder);
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductDataFilter, Relewise.Client',
                key: key,
                filterOutIfKeyIsNotFound: filterOutIfKeyIsNotFound,
                mustMatchAllConditions: mustMatchAllConditions,
                conditions: builder.build(),
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a variant data filter to the request
         * @param key
         * @param conditionBuilder
         * @param mustMatchAllConditions
         * @param filterOutIfKeyIsNotFound
         * @param negated
         */
        addVariantDataFilter(key, conditionBuilder, mustMatchAllConditions = true, filterOutIfKeyIsNotFound = true, negated = false) {
            const builder = new ConditionBuilder();
            conditionBuilder(builder);
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.VariantDataFilter, Relewise.Client',
                key: key,
                filterOutIfKeyIsNotFound: filterOutIfKeyIsNotFound,
                mustMatchAllConditions: mustMatchAllConditions,
                conditions: builder.build(),
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a brand data filter to the request
         * @param key
         * @param conditionBuilder
         * @param mustMatchAllConditions
         * @param filterOutIfKeyIsNotFound
         * @param negated
         */
        addBrandDataFilter(key, conditionBuilder, mustMatchAllConditions = true, filterOutIfKeyIsNotFound = true, negated = false) {
            const builder = new ConditionBuilder();
            conditionBuilder(builder);
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.BrandDataFilter, Relewise.Client',
                key: key,
                filterOutIfKeyIsNotFound: filterOutIfKeyIsNotFound,
                mustMatchAllConditions: mustMatchAllConditions,
                conditions: builder.build(),
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a cart data filter to the request
         * @param key
         * @param conditionBuilder
         * @param mustMatchAllConditions
         * @param filterOutIfKeyIsNotFound
         * @param negated
         */
        addCartDataFilter(key, conditionBuilder, mustMatchAllConditions = true, filterOutIfKeyIsNotFound = true, negated = false) {
            const builder = new ConditionBuilder();
            conditionBuilder(builder);
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.CartDataFilter, Relewise.Client',
                key: key,
                filterOutIfKeyIsNotFound: filterOutIfKeyIsNotFound,
                mustMatchAllConditions: mustMatchAllConditions,
                conditions: builder.build(),
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a cart data filter to the request
         * @param key
         * @param conditionBuilder
         * @param mustMatchAllConditions
         * @param filterOutIfKeyIsNotFound
         * @param negated
         */
        addContentCategoryDataFilter(key, conditionBuilder, mustMatchAllConditions = true, filterOutIfKeyIsNotFound = true, negated = false) {
            const builder = new ConditionBuilder();
            conditionBuilder(builder);
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ContentCategoryDataFilter, Relewise.Client',
                key: key,
                filterOutIfKeyIsNotFound: filterOutIfKeyIsNotFound,
                mustMatchAllConditions: mustMatchAllConditions,
                conditions: builder.build(),
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a content data filter to the request
         * @param key
         * @param conditionBuilder
         * @param mustMatchAllConditions
         * @param filterOutIfKeyIsNotFound
         * @param negated
         */
        addContentDataFilter(key, conditionBuilder, mustMatchAllConditions = true, filterOutIfKeyIsNotFound = true, negated = false) {
            const builder = new ConditionBuilder();
            conditionBuilder(builder);
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ContentDataFilter, Relewise.Client',
                key: key,
                filterOutIfKeyIsNotFound: filterOutIfKeyIsNotFound,
                mustMatchAllConditions: mustMatchAllConditions,
                conditions: builder.build(),
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
         * Adds a product category data filter to the request
         * @param key
         * @param conditionBuilder
         * @param mustMatchAllConditions
         * @param filterOutIfKeyIsNotFound
         * @param negated
         */
        addProductCategoryDataFilter(key, conditionBuilder, mustMatchAllConditions = true, filterOutIfKeyIsNotFound = true, negated = false) {
            const builder = new ConditionBuilder();
            conditionBuilder(builder);
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductCategoryDataFilter, Relewise.Client',
                key: key,
                filterOutIfKeyIsNotFound: filterOutIfKeyIsNotFound,
                mustMatchAllConditions: mustMatchAllConditions,
                conditions: builder.build(),
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
        * Adds a product display name filter to the request
        * @param key
        * @param conditionBuilder
        * @param mustMatchAllConditions
        * @param filterOutIfKeyIsNotFound
        * @param negated
        */
        addProductDisplayNameFilter(conditionBuilder, mustMatchAllConditions = true, negated = false) {
            const builder = new ConditionBuilder();
            conditionBuilder(builder);
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductDisplayNameFilter, Relewise.Client',
                mustMatchAllConditions: mustMatchAllConditions,
                conditions: builder.build(),
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
        * Adds a product variant filter to the request
        * @param products
        * @param negated
        */
        addProductAndVariantIdFilter(products, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductAndVariantIdFilter, Relewise.Client',
                productAndVariantIds: Array.isArray(products) ? products : [products],
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
        * Adds a product category level filter to the request
        * @param levels
        * @param negated
        */
        addProductCategoryLevelFilter(levels, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductCategoryLevelFilter, Relewise.Client',
                levels: Array.isArray(levels) ? levels : [levels],
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
        * Adds a product category has parent filter to the request
        * @param categoryIds
        * @param negated
        */
        addProductCategoryHasParentFilter(categoryIds, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductCategoryHasParentFilter, Relewise.Client',
                categoryIds: categoryIds ? (Array.isArray(categoryIds) ? categoryIds : [categoryIds]) : undefined,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
        * Adds a product category has child filter to the request
        * @param categoryIds
        * @param negated
        */
        addProductCategoryHasChildFilter(categoryIds, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductCategoryHasChildFilter, Relewise.Client',
                categoryIds: categoryIds ? (Array.isArray(categoryIds) ? categoryIds : [categoryIds]) : undefined,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
        * Adds a product category has ancestor filter to the request
        * @param categoryIds
        * @param negated
        */
        addProductCategoryHasAncestorFilter(categoryIds, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ProductCategoryHasAncestorFilter, Relewise.Client',
                categoryIds: categoryIds ? (Array.isArray(categoryIds) ? categoryIds : [categoryIds]) : undefined,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
        * Adds a content category level filter to the request
        * @param levels
        * @param negated
        */
        addContentCategoryLevelFilter(levels, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ContentCategoryLevelFilter, Relewise.Client',
                levels: Array.isArray(levels) ? levels : [levels],
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
        * Adds a content category has parent filter to the request
        * @param categoryIds
        * @param negated
        */
        addContentCategoryHasParentFilter(categoryIds, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ContentCategoryHasParentFilter, Relewise.Client',
                categoryIds: categoryIds ? (Array.isArray(categoryIds) ? categoryIds : [categoryIds]) : undefined,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
        * Adds a content category has child filter to the request
        * @param categoryIds
        * @param negated
        */
        addContentCategoryHasChildFilter(categoryIds, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ContentCategoryHasChildFilter, Relewise.Client',
                categoryIds: categoryIds ? (Array.isArray(categoryIds) ? categoryIds : [categoryIds]) : undefined,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        /**
        * Adds a content category has ancestor filter to the request
        * @param categoryIds
        * @param negated
        */
        addContentCategoryHasAncestorFilter(categoryIds, negated = false) {
            const filter = {
                $type: 'Relewise.Client.Requests.Filters.ContentCategoryHasAncestorFilter, Relewise.Client',
                categoryIds: categoryIds ? (Array.isArray(categoryIds) ? categoryIds : [categoryIds]) : undefined,
                negated: negated,
            };
            this.filters.push(filter);
            return this;
        }
        reset() {
            this.filters = [];
            return this;
        }
        build() {
            return this.filters.length === 0
                ? null
                : { items: this.filters };
        }
    }

    class PaginationBuilder {
        constructor() {
            this.pageNumber = 1;
            this.pageSize = 10;
        }
        /**
         * Defines how many results to return
         * @param pageSize
         * @returns
         */
        setPageSize(pageSize) {
            if (pageSize < 0) {
                throw new Error('pageSize can not be below 0');
            }
            this.pageSize = pageSize;
            return this;
        }
        /**
         * Page starts at 1, so this to skip 'X' pages of results
         * @param pageNumber
         * @returns
         */
        setPage(pageNumber) {
            if (pageNumber < 1) {
                throw new Error('pageNumber can not be below 1');
            }
            this.pageNumber = pageNumber;
            return this;
        }
        build() {
            return {
                take: this.pageSize,
                skip: (this.pageNumber - 1) * this.pageSize,
            };
        }
    }

    class RelevanceModifierBuilder {
        constructor() {
            this.modifiers = [];
        }
        addBrandIdRelevanceModifier(brandId, ifProductIsBrandMultiplyWeightBy = 1, ifProductIsNotBrandMultiplyWeightBy = 1, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.BrandIdRelevanceModifier, Relewise.Client',
                ifProductIsBrandMultiplyWeightBy: ifProductIsBrandMultiplyWeightBy,
                ifProductIsNotBrandMultiplyWeightBy: ifProductIsNotBrandMultiplyWeightBy,
                brandId: brandId,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addProductAssortmentRelevanceModifier(assortments, multiplyWeightBy = 1, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.ProductAssortmentRelevanceModifier, Relewise.Client',
                assortments: assortments,
                multiplyWeightBy: multiplyWeightBy,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addVariantAssortmentRelevanceModifier(assortments, multiplyWeightBy = 1, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.VariantAssortmentRelevanceModifier, Relewise.Client',
                assortments: assortments,
                multiplyWeightBy: multiplyWeightBy,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addProductCategoryIdRelevanceModifier(categoryId, evaluationScope, multiplyWeightBy = 1, negated = false, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.ProductCategoryIdRelevanceModifier, Relewise.Client',
                categoryId: categoryId,
                evaluationScope: evaluationScope,
                negated: negated,
                multiplyWeightBy: multiplyWeightBy,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addProductDataRelevanceModifier(key, conditions, multiplierSelector, mustMatchAllConditions = true, considerAsMatchIfKeyIsNotFound = false, filter) {
            var _a;
            const conditionBuilder = new ConditionBuilder();
            conditions(conditionBuilder);
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.ProductDataRelevanceModifier, Relewise.Client',
                key: key,
                considerAsMatchIfKeyIsNotFound: considerAsMatchIfKeyIsNotFound,
                mustMatchAllConditions: mustMatchAllConditions,
                conditions: (_a = conditionBuilder.build()) === null || _a === void 0 ? void 0 : _a.items,
                multiplierSelector: multiplierSelector,
                multiplyWeightBy: 0,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addVariantDataRelevanceModifier(key, conditions, multiplierSelector, mustMatchAllConditions = true, considerAsMatchIfKeyIsNotFound = false, filter) {
            var _a;
            const conditionBuilder = new ConditionBuilder();
            conditions(conditionBuilder);
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.VariantDataRelevanceModifier, Relewise.Client',
                key: key,
                considerAsMatchIfKeyIsNotFound: considerAsMatchIfKeyIsNotFound,
                mustMatchAllConditions: mustMatchAllConditions,
                conditions: (_a = conditionBuilder.build()) === null || _a === void 0 ? void 0 : _a.items,
                multiplierSelector: multiplierSelector,
                multiplyWeightBy: 0,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addProductIdRelevanceModifier(productIds, multiplyWeightBy = 1, negated = false, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.ProductIdRelevanceModifier, Relewise.Client',
                productIds: productIds,
                negated: negated,
                multiplyWeightBy: multiplyWeightBy,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addProductListPriceRelevanceModifier(currency, lowerBound, upperBound, multiplyWeightBy = 1, negated = false, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.ProductListPriceRelevanceModifier, Relewise.Client',
                range: { lowerBoundInclusive: lowerBound, upperBoundInclusive: upperBound },
                currency: { value: currency },
                negated: negated,
                multiplyWeightBy: multiplyWeightBy,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addProductSalesPriceRelevanceModifier(currency, lowerBound, upperBound, multiplyWeightBy = 1, negated = false, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.ProductSalesPriceRelevanceModifier, Relewise.Client',
                range: { lowerBoundInclusive: lowerBound, upperBoundInclusive: upperBound },
                currency: { value: currency },
                negated: negated,
                multiplyWeightBy: multiplyWeightBy,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addVariantListPriceRelevanceModifier(currency, lowerBound, upperBound, multiplyWeightBy = 1, negated = false, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.VariantListPriceRelevanceModifier, Relewise.Client',
                range: { lowerBoundInclusive: lowerBound, upperBoundInclusive: upperBound },
                currency: { value: currency },
                negated: negated,
                multiplyWeightBy: multiplyWeightBy,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addVariantSalesPriceRelevanceModifier(currency, lowerBound, upperBound, multiplyWeightBy = 1, negated = false, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.VariantSalesPriceRelevanceModifier, Relewise.Client',
                range: { lowerBoundInclusive: lowerBound, upperBoundInclusive: upperBound },
                currency: { value: currency },
                negated: negated,
                multiplyWeightBy: multiplyWeightBy,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addVariantSpecificationsInCommonRelevanceModifier(specificationKeysAndMultipliers, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.VariantSpecificationsInCommonRelevanceModifier, Relewise.Client',
                specificationKeysAndMultipliers,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addVariantSpecificationValueRelevanceModifier(key, value, ifIdenticalMultiplyWeightBy = 1, ifNotIdenticalMultiplyWeightBy = 0, ifSpecificationKeyNotFoundApplyNotEqualMultiplier = false, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.VariantSpecificationValueRelevanceModifier, Relewise.Client',
                key,
                value,
                ifIdenticalMultiplyWeightBy,
                ifNotIdenticalMultiplyWeightBy,
                ifSpecificationKeyNotFoundApplyNotEqualMultiplier,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addProductRecentlyPurchasedByUserRelevanceModifier(sinceUtc, ifNotPreviouslyPurchasedByUserMultiplyWeightBy = 1, ifPreviouslyPurchasedByUserMultiplyWeightBy = 1, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.ProductRecentlyPurchasedByUserRelevanceModifier, Relewise.Client',
                ifNotPreviouslyPurchasedByUserMultiplyWeightBy,
                ifPreviouslyPurchasedByUserMultiplyWeightBy,
                sinceUtc: sinceUtc.toJSON(),
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addProductRecentlyViewedByUserRelevanceModifier(sinceUtc, ifNotPreviouslyViewedByUserMultiplyWeightBy = 1, ifPreviouslyViewedByUserMultiplyWeightBy = 1, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.ProductRecentlyViewedByUserRelevanceModifier, Relewise.Client',
                ifNotPreviouslyViewedByUserMultiplyWeightBy,
                ifPreviouslyViewedByUserMultiplyWeightBy,
                sinceUtc: sinceUtc.toJSON(),
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        addUserFavoriteProductRelevanceModifier(sinceMinutesAgo, ifNotPurchasedBaseWeight = 1, mostRecentPurchaseWeight = 1, numberOfPurchasesWeight = 1, filter) {
            const filterBuilder = new FilterBuilder();
            if (filter) {
                filter(filterBuilder);
            }
            const modifier = {
                $type: 'Relewise.Client.Requests.RelevanceModifiers.UserFavoriteProductRelevanceModifier, Relewise.Client',
                ifNotPurchasedBaseWeight,
                mostRecentPurchaseWeight,
                numberOfPurchasesWeight,
                sinceMinutesAgo: sinceMinutesAgo,
                filters: filterBuilder.build(),
            };
            this.modifiers.push(modifier);
            return this;
        }
        build() {
            return this.modifiers.length === 0
                ? null
                : { items: this.modifiers };
        }
    }

    class DataObjectFacetBuilder {
        constructor() {
            this.facets = [];
        }
        addDataObjectFacet(key, builder, filter, facetSettings) {
            var _a, _b;
            const facetBuilder = new DataObjectFacetBuilder();
            if (builder) {
                builder(facetBuilder);
            }
            const conditionsBuilder = new DataObjectFilterConditionBuilder();
            if (filter === null || filter === void 0 ? void 0 : filter.conditions) {
                filter === null || filter === void 0 ? void 0 : filter.conditions(conditionsBuilder);
            }
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.DataObjectFacet, Relewise.Client',
                field: 'Data',
                key: key,
                items: (_a = facetBuilder.build()) !== null && _a !== void 0 ? _a : [],
                filter: {
                    conditions: (_b = conditionsBuilder.build()) !== null && _b !== void 0 ? _b : [],
                    take: filter === null || filter === void 0 ? void 0 : filter.take,
                    skip: filter === null || filter === void 0 ? void 0 : filter.skip,
                },
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addStringFacet(key, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.DataObjectStringValueFacet, Relewise.Client',
                field: 'Data',
                key: key,
                selected: selectedValues,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addBooleanFacet(key, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.DataObjectBooleanValueFacet, Relewise.Client',
                field: 'Data',
                key: key,
                selected: selectedValues,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addNumberFacet(key, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.DataObjectDoubleValueFacet, Relewise.Client',
                field: 'Data',
                key: key,
                selected: selectedValues,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addNumberRangeFacet(key, lowerBound, upperBound, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.DataObjectDoubleRangeFacet, Relewise.Client',
                field: 'Data',
                key: key,
                selected: {
                    lowerBoundInclusive: lowerBound,
                    upperBoundInclusive: upperBound,
                },
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addNumberRangesFacet(key, predefinedRanges, expandedRangeSize, selectedValues = null, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.DataObjectDoubleRangesFacet, Relewise.Client',
                field: 'Data',
                key: key,
                settings: facetSettings,
                predefinedRanges: predefinedRanges === null || predefinedRanges === void 0 ? void 0 : predefinedRanges.map(x => ({ lowerBoundInclusive: x.lowerBound, upperBoundExclusive: x.upperBound })),
                expandedRangeSize: expandedRangeSize,
                selected: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(x => ({ lowerBoundInclusive: x.lowerBound, upperBoundExclusive: x.upperBound })),
            };
            this.facets.push(facet);
            return this;
        }
        build() {
            return this.facets.length === 0
                ? null
                : this.facets;
        }
    }

    class FacetBuilder {
        constructor() {
            this.facets = [];
        }
        //#region Product
        addCategoryFacet(categorySelectionStrategy, selectedValues = null, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.CategoryFacet, Relewise.Client',
                categorySelectionStrategy: categorySelectionStrategy,
                field: 'Category',
                selected: selectedValues,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductCategoryHierarchyFacet(categorySelectionStrategy, selectedValues = null, selectedPropertiesSettings, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.CategoryHierarchyFacet, Relewise.Client',
                categorySelectionStrategy: categorySelectionStrategy,
                field: 'Category',
                selected: selectedValues,
                settings: facetSettings,
                selectedPropertiesSettings: selectedPropertiesSettings ? Object.assign({ $type: 'Relewise.Client.Requests.Shared.SelectedProductCategoryPropertiesSettings, Relewise.Client' }, selectedPropertiesSettings) : undefined,
            };
            this.facets.push(facet);
            return this;
        }
        addContentCategoryHierarchyFacet(categorySelectionStrategy, selectedValues = null, selectedPropertiesSettings, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.CategoryHierarchyFacet, Relewise.Client',
                categorySelectionStrategy: categorySelectionStrategy,
                field: 'Category',
                selected: selectedValues,
                settings: facetSettings,
                selectedPropertiesSettings: selectedPropertiesSettings ? Object.assign({ $type: 'Relewise.Client.Requests.Shared.SelectedContentCategoryPropertiesSettings, Relewise.Client' }, selectedPropertiesSettings) : undefined,
            };
            this.facets.push(facet);
            return this;
        }
        addBrandFacet(selectedValues = null, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.BrandFacet, Relewise.Client',
                field: 'Brand',
                selected: selectedValues,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductAssortmentFacet(selectionStrategy, selectedValues = null, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductAssortmentFacet, Relewise.Client',
                field: 'Assortment',
                assortmentFilterType: 'Or',
                assortmentSelectionStrategy: selectionStrategy,
                selected: selectedValues,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addVariantSpecificationFacet(key, selectedValues = null, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.VariantSpecificationFacet, Relewise.Client',
                field: 'VariantSpecification',
                key: key,
                selected: selectedValues,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductDataDoubleRangeFacet(key, selectionStrategy, lowerBound, upperBound, facetSettings) {
            const selected = this.mapSelectedDoubleRange(lowerBound, upperBound);
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductDataDoubleRangeFacet, Relewise.Client',
                field: 'Data',
                key: key,
                dataSelectionStrategy: selectionStrategy,
                selected: selected,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductDataDoubleRangesFacet(key, selectionStrategy, predefinedRanges, expandedRangeSize, selectedValues = null, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductDataDoubleRangesFacet, Relewise.Client',
                field: 'Data',
                key: key,
                predefinedRanges: predefinedRanges === null || predefinedRanges === void 0 ? void 0 : predefinedRanges.map(x => ({ lowerBoundInclusive: x.lowerBound, upperBoundExclusive: x.upperBound })),
                expandedRangeSize: expandedRangeSize,
                selected: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(x => ({ lowerBoundInclusive: x.lowerBound, upperBoundExclusive: x.upperBound })),
                dataSelectionStrategy: selectionStrategy,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductDataStringValueFacet(key, selectionStrategy, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductDataStringValueFacet, Relewise.Client',
                field: 'Data',
                key: key,
                dataSelectionStrategy: selectionStrategy,
                selected: selectedValues,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductDataBooleanValueFacet(key, selectionStrategy, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductDataBooleanValueFacet, Relewise.Client',
                field: 'Data',
                key: key,
                dataSelectionStrategy: selectionStrategy,
                selected: selectedValues,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductDataDoubleValueFacet(key, selectionStrategy, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductDataDoubleValueFacet, Relewise.Client',
                field: 'Data',
                key: key,
                dataSelectionStrategy: selectionStrategy,
                selected: selectedValues,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addSalesPriceRangeFacet(priceSelectionStrategy, lowerBound, upperBound, facetSettings) {
            const selected = this.mapSelectedDoubleRange(lowerBound, upperBound);
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.PriceRangeFacet, Relewise.Client',
                field: 'SalesPrice',
                selected: selected,
                priceSelectionStrategy,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addListPriceRangeFacet(priceSelectionStrategy, lowerBound, upperBound, facetSettings) {
            const selected = this.mapSelectedDoubleRange(lowerBound, upperBound);
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.PriceRangeFacet, Relewise.Client',
                field: 'ListPrice',
                selected: selected,
                priceSelectionStrategy,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addListPriceRangesFacet(priceSelectionStrategy, predefinedRanges, expandedRangeSize, selectedValues = null, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.PriceRangesFacet, Relewise.Client',
                field: 'ListPrice',
                predefinedRanges: predefinedRanges === null || predefinedRanges === void 0 ? void 0 : predefinedRanges.map(x => ({ lowerBoundInclusive: x.lowerBound, upperBoundExclusive: x.upperBound })),
                expandedRangeSize: expandedRangeSize,
                selected: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(x => ({ lowerBoundInclusive: x.lowerBound, upperBoundExclusive: x.upperBound })),
                priceSelectionStrategy,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductDataObjectFacet(key, selectionStrategy, builder, filter, facetSettings) {
            var _a, _b;
            const facetBuilder = new DataObjectFacetBuilder();
            if (builder) {
                builder(facetBuilder);
            }
            const conditionsBuilder = new DataObjectFilterConditionBuilder();
            if (filter === null || filter === void 0 ? void 0 : filter.conditions) {
                filter === null || filter === void 0 ? void 0 : filter.conditions(conditionsBuilder);
            }
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductDataObjectFacet, Relewise.Client',
                field: 'Data',
                items: (_a = facetBuilder.build()) !== null && _a !== void 0 ? _a : [],
                filter: {
                    conditions: (_b = conditionsBuilder.build()) !== null && _b !== void 0 ? _b : [],
                    take: filter === null || filter === void 0 ? void 0 : filter.take,
                    skip: filter === null || filter === void 0 ? void 0 : filter.skip,
                },
                dataSelectionStrategy: selectionStrategy,
                settings: facetSettings,
                key: key,
            };
            this.facets.push(facet);
            return this;
        }
        //#endregion
        //#region Content
        addContentAssortmentFacet(selectedValues = null, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ContentAssortmentFacet, Relewise.Client',
                field: 'Assortment',
                assortmentFilterType: 'Or',
                selected: selectedValues,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addContentDataDoubleRangeFacet(key, lowerBound, upperBound, facetSettings) {
            const selected = this.mapSelectedDoubleRange(lowerBound, upperBound);
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ContentDataDoubleRangeFacet, Relewise.Client',
                field: 'Data',
                selected: selected,
                key: key,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addContentDataDoubleRangesFacet(key, predefinedRanges, expandedRangeSize, selectedValues = null, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductDataDoubleRangesFacet, Relewise.Client',
                field: 'Data',
                key: key,
                predefinedRanges: predefinedRanges === null || predefinedRanges === void 0 ? void 0 : predefinedRanges.map(x => ({ lowerBoundInclusive: x.lowerBound, upperBoundExclusive: x.upperBound })),
                expandedRangeSize: expandedRangeSize,
                selected: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(x => ({ lowerBoundInclusive: x.lowerBound, upperBoundExclusive: x.upperBound })),
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addContentDataStringValueFacet(key, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ContentDataStringValueFacet, Relewise.Client',
                field: 'Data',
                selected: selectedValues,
                key: key,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addContentDataBooleanValueFacet(key, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ContentDataBooleanValueFacet, Relewise.Client',
                field: 'Data',
                selected: selectedValues,
                key: key,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addContentDataDoubleValueFacet(key, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ContentDataDoubleValueFacet, Relewise.Client',
                field: 'Data',
                selected: selectedValues,
                key: key,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        //#endregion
        //#region ProductCategories
        addProductCategoryAssortmentFacet(selectedValues = null, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductCategoryAssortmentFacet, Relewise.Client',
                field: 'Assortment',
                assortmentFilterType: 'Or',
                selected: selectedValues,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductCategoryDataDoubleRangeFacet(key, lowerBound, upperBound, facetSettings) {
            const selected = this.mapSelectedDoubleRange(lowerBound, upperBound);
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductCategoryDataDoubleRangeFacet, Relewise.Client',
                field: 'Data',
                selected: selected,
                key: key,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductCategoryDataDoubleRangesFacet(key, predefinedRanges, expandedRangeSize, selectedValues = null, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductDataDoubleRangesFacet, Relewise.Client',
                field: 'Data',
                key: key,
                predefinedRanges: predefinedRanges === null || predefinedRanges === void 0 ? void 0 : predefinedRanges.map(x => ({ lowerBoundInclusive: x.lowerBound, upperBoundExclusive: x.upperBound })),
                expandedRangeSize: expandedRangeSize,
                selected: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(x => ({ lowerBoundInclusive: x.lowerBound, upperBoundExclusive: x.upperBound })),
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductCategoryDataStringValueFacet(key, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductCategoryDataStringValueFacet, Relewise.Client',
                field: 'Data',
                selected: selectedValues,
                key: key,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductCategoryDataBooleanValueFacet(key, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductCategoryDataBooleanValueFacet, Relewise.Client',
                field: 'Data',
                selected: selectedValues,
                key: key,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        addProductCategoryDataDoubleValueFacet(key, selectedValues = null, collectionFilterType, facetSettings) {
            const facet = {
                $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.ProductCategoryDataDoubleValueFacet, Relewise.Client',
                field: 'Data',
                selected: selectedValues,
                key: key,
                collectionFilterType: collectionFilterType,
                settings: facetSettings,
            };
            this.facets.push(facet);
            return this;
        }
        //#endregion
        build() {
            return this.facets.length === 0
                ? null
                : {
                    items: this.facets,
                    $type: 'Relewise.Client.DataTypes.Search.Facets.Queries.FacetQuery, Relewise.Client',
                };
        }
        mapSelectedDoubleRange(lowerBound, upperBound) {
            let selected = null;
            const lowerBoundHasValue = lowerBound !== null && lowerBound !== undefined;
            const upperBoundHasValue = upperBound !== null && upperBound !== undefined;
            if (lowerBoundHasValue || upperBoundHasValue) {
                selected = {};
                if (lowerBoundHasValue)
                    selected.lowerBoundInclusive = lowerBound;
                if (upperBoundHasValue)
                    selected.upperBoundInclusive = upperBound;
            }
            return selected;
        }
    }

    class ProductSortingBuilder {
        constructor() {
            this.value = null;
        }
        sortByProductData(key, selectionStrategy, order, thenBy, mode = 'Auto') {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.Product.ProductDataSorting, Relewise.Client',
                dataSelectionStrategy: selectionStrategy,
                mode,
                order,
                key,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        sortByProductRelevance(order = 'Descending', thenBy) {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.Product.ProductRelevanceSorting, Relewise.Client',
                order,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        sortByProductPopularity(order = 'Descending', thenBy) {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.Product.ProductPopularitySorting, Relewise.Client',
                order,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        sortByProductAttribute(attribute, order, thenBy, mode = 'Auto') {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.Product.ProductAttributeSorting, Relewise.Client',
                attribute,
                mode,
                order,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        sortByProductVariantAttribute(attribute, order, thenBy, mode = 'Auto') {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.Product.ProductVariantAttributeSorting, Relewise.Client',
                attribute,
                mode,
                order,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        sortByProductVariantSpecification(key, order, thenBy, mode = 'Auto') {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.Product.ProductVariantSpecificationSorting, Relewise.Client',
                key,
                mode,
                order,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        thenBy(thenBy) {
            const thenByBuilder = new ProductSortingBuilder();
            if (thenBy) {
                thenBy(thenByBuilder);
                thenByBuilder.build();
            }
            return thenByBuilder;
        }
        build() {
            return this.value == null
                ? null
                : { value: this.value };
        }
    }

    class ContentSortingBuilder {
        constructor() {
            this.value = null;
        }
        sortByContentData(key, order = 'Descending', mode = 'Auto', thenBy) {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.Content.ContentDataSorting, Relewise.Client',
                mode,
                order,
                key,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        sortByContentRelevance(order = 'Descending', thenBy) {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.Content.ContentRelevanceSorting, Relewise.Client',
                order,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        sortByContentPopularity(order = 'Descending', thenBy) {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.Content.ContentPopularitySorting, Relewise.Client',
                order,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        sortByContentAttribute(attribute, order, mode = 'Auto', thenBy) {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.Content.ContentAttributeSorting, Relewise.Client',
                attribute,
                mode,
                order,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        thenBy(thenBy) {
            const thenByBuilder = new ContentSortingBuilder();
            if (thenBy) {
                thenBy(thenByBuilder);
                thenByBuilder.build();
            }
            return thenByBuilder;
        }
        build() {
            return this.value == null
                ? null
                : { value: this.value };
        }
    }

    class ProductCategorySortingBuilder {
        constructor() {
            this.value = null;
        }
        sortByProductCategoryData(key, order = 'Descending', mode = 'Auto', thenBy) {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.ProductCategory.ProductCategoryDataSorting, Relewise.Client',
                mode,
                order,
                key,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        sortByProductCategoryRelevance(order = 'Descending', thenBy) {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.ProductCategory.ProductCategoryRelevanceSorting, Relewise.Client',
                order,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        sortByProductCategoryPopularity(order = 'Descending', thenBy) {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.ProductCategory.ProductCategoryPopularitySorting, Relewise.Client',
                order,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        sortByProductCategoryAttribute(attribute, order, mode = 'Auto', thenBy) {
            var _a;
            const sort = {
                $type: 'Relewise.Client.DataTypes.Search.Sorting.ProductCategory.ProductCategoryAttributeSorting, Relewise.Client',
                attribute,
                mode,
                order,
                thenBy: (_a = this.thenBy(thenBy)) === null || _a === void 0 ? void 0 : _a.value,
            };
            this.value = sort;
        }
        thenBy(thenBy) {
            const thenByBuilder = new ProductCategorySortingBuilder();
            if (thenBy) {
                thenBy(thenByBuilder);
            }
            return thenByBuilder;
        }
        build() {
            return this.value == null
                ? null
                : { value: this.value };
        }
    }

    class SearchRequestBuilder {
        constructor(settings) {
            this.settings = settings;
            this.filterBuilder = new FilterBuilder();
            this.postFilterBuilder = new FilterBuilder();
            this.relevanceModifiersBuilder = new RelevanceModifierBuilder();
        }
        /**
         * Adds filters to the request
         * @param filterBuilder
         * @returns
         */
        filters(filterBuilder) {
            filterBuilder(this.filterBuilder);
            return this;
        }
        /**
         * Adds post filters to the request
         * @param filterBuilder
         * @returns
         */
        postFilters(filterBuilder) {
            filterBuilder(this.postFilterBuilder);
            return this;
        }
        relevanceModifiers(relevanceModifiersBuilder) {
            relevanceModifiersBuilder(this.relevanceModifiersBuilder);
            return this;
        }
        /**
         * Use only when a specific index different from the 'default'-index is needed
         * @param id
         * @returns
         */
        setIndex(id) {
            this.indexId = id;
            return this;
        }
        baseBuild() {
            return Object.assign(Object.assign(Object.assign({}, (this.settings && {
                currency: { value: this.settings.currency },
                language: { value: this.settings.language },
                displayedAtLocation: this.settings.displayedAtLocation,
                user: this.settings.user,
            })), { filters: this.filterBuilder.build(), postFilters: this.postFilterBuilder.build(), relevanceModifiers: this.relevanceModifiersBuilder.build() }), (this.indexId && { indexSelector: { id: this.indexId } }));
        }
    }

    class ContentSearchBuilder extends SearchRequestBuilder {
        constructor(settings) {
            super(settings);
            this.facetBuilder = new FacetBuilder();
            this.paginationBuilder = new PaginationBuilder();
            this.sortingBuilder = new ContentSortingBuilder();
            this.searchSettings = {
                $type: 'Relewise.Client.Requests.Search.Settings.ContentSearchSettings, Relewise.Client',
                recommendations: {},
            };
        }
        setContentProperties(contentProperties) {
            this.searchSettings.selectedContentProperties = contentProperties;
            return this;
        }
        setRecommendationSettings(settings) {
            this.searchSettings.recommendations = settings;
            return this;
        }
        setTerm(term) {
            this.term = term;
            return this;
        }
        pagination(paginate) {
            paginate(this.paginationBuilder);
            return this;
        }
        facets(facets) {
            facets(this.facetBuilder);
            return this;
        }
        sorting(sorting) {
            sorting(this.sortingBuilder);
            return this;
        }
        build() {
            const { take, skip } = this.paginationBuilder.build();
            return Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Search.ContentSearchRequest, Relewise.Client' }, this.baseBuild()), { settings: this.searchSettings, take,
                skip, term: this.term, facets: this.facetBuilder.build(), sorting: this.sortingBuilder.build() });
        }
    }

    class ProductCategorySearchBuilder extends SearchRequestBuilder {
        constructor(settings) {
            super(settings);
            this.facetBuilder = new FacetBuilder();
            this.paginationBuilder = new PaginationBuilder();
            this.sortingBuilder = new ProductCategorySortingBuilder();
            this.searchSettings = {
                $type: 'Relewise.Client.Requests.Search.Settings.ProductCategorySearchSettings, Relewise.Client',
                recommendations: {},
            };
        }
        setSelectedCategoryProperties(productCategoryProperties) {
            this.searchSettings.selectedCategoryProperties = productCategoryProperties;
            return this;
        }
        setRecommendationSettings(settings) {
            this.searchSettings.recommendations = settings;
            return this;
        }
        /**
         * Set the term used to filter product categories by
         */
        setTerm(term) {
            this.term = term;
            return this;
        }
        pagination(paginate) {
            paginate(this.paginationBuilder);
            return this;
        }
        facets(facets) {
            facets(this.facetBuilder);
            return this;
        }
        sorting(sorting) {
            sorting(this.sortingBuilder);
            return this;
        }
        build() {
            const { take, skip } = this.paginationBuilder.build();
            return Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Search.ProductCategorySearchRequest, Relewise.Client' }, this.baseBuild()), { take,
                skip, term: this.term, facets: this.facetBuilder.build(), settings: this.searchSettings, sorting: this.sortingBuilder.build() });
        }
    }

    class ProductSearchBuilder extends SearchRequestBuilder {
        constructor(settings) {
            super(settings);
            this.facetBuilder = new FacetBuilder();
            this.paginationBuilder = new PaginationBuilder();
            this.sortingBuilder = new ProductSortingBuilder();
            this.searchSettings = {
                $type: 'Relewise.Client.Requests.Search.Settings.ProductSearchSettings, Relewise.Client',
                recommendations: {},
            };
        }
        setSelectedProductProperties(productProperties) {
            this.searchSettings.selectedProductProperties = productProperties;
            return this;
        }
        setSelectedVariantProperties(variantProperties) {
            this.searchSettings.selectedVariantProperties = variantProperties;
            return this;
        }
        setSelectedBrandProperties(brandProperties) {
            this.searchSettings.selectedBrandProperties = brandProperties;
            return this;
        }
        setVariantSearchSettings(variantSearchSettings) {
            this.searchSettings.variantSettings = variantSearchSettings;
            return this;
        }
        setExplodedVariants(count) {
            this.searchSettings.explodedVariants = count;
            return this;
        }
        setRecommendationSettings(settings) {
            this.searchSettings.recommendations = settings;
            return this;
        }
        /**
         * Set the term used to filter products by
         */
        setTerm(term) {
            this.term = term;
            return this;
        }
        pagination(paginate) {
            paginate(this.paginationBuilder);
            return this;
        }
        facets(facets) {
            facets(this.facetBuilder);
            return this;
        }
        sorting(sorting) {
            sorting(this.sortingBuilder);
            return this;
        }
        build() {
            const { take, skip } = this.paginationBuilder.build();
            return Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Search.ProductSearchRequest, Relewise.Client' }, this.baseBuild()), { take,
                skip, term: this.term, facets: this.facetBuilder.build(), settings: this.searchSettings, sorting: this.sortingBuilder.build() });
        }
    }

    class SearchCollectionBuilder extends SearchRequestBuilder {
        constructor(settings) {
            super(settings);
            this.requests = [];
        }
        addRequest(request) {
            this.requests.push(request);
            return this;
        }
        build() {
            return Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Search.SearchRequestCollection, Relewise.Client' }, this.baseBuild()), { requests: this.requests });
        }
    }

    class SearchTermPredictionBuilder extends SearchRequestBuilder {
        constructor(settings) {
            super(settings);
            this.count = 0;
            this.term = '';
            this.targetEntityTypes = null;
        }
        take(count) {
            this.count = count;
            return this;
        }
        setTerm(term) {
            this.term = term;
            return this;
        }
        addEntityType(...types) {
            this.targetEntityTypes = types;
            return this;
        }
        build() {
            return Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Search.SearchTermPredictionRequest, Relewise.Client' }, this.baseBuild()), { term: this.term, take: this.count, settings: {
                    $type: 'Relewise.Client.Requests.Search.Settings.SearchTermPredictionSettings, Relewise.Client',
                    targetEntityTypes: this.targetEntityTypes,
                } });
        }
    }

    class RecommendationRequestBuilder {
        constructor(settings) {
            this.settings = settings;
            this.filterBuilder = new FilterBuilder();
            this.relevanceModifiersBuilder = new RelevanceModifierBuilder();
        }
        /**
         * Adds filters to the request
         * @param filterBuilder
         * @returns
         */
        filters(filterBuilder) {
            filterBuilder(this.filterBuilder);
            return this;
        }
        relevanceModifiers(relevanceModifiersBuilder) {
            relevanceModifiersBuilder(this.relevanceModifiersBuilder);
            return this;
        }
        baseBuild() {
            var _a, _b;
            return {
                currency: { value: this.settings.currency },
                user: this.settings.user,
                language: { value: this.settings.language },
                displayedAtLocationType: this.settings.displayedAtLocation,
                filters: (_a = this.filterBuilder.build()) !== null && _a !== void 0 ? _a : {},
                relevanceModifiers: (_b = this.relevanceModifiersBuilder.build()) !== null && _b !== void 0 ? _b : {},
            };
        }
    }

    class ContentSettingsRecommendationBuilder extends RecommendationRequestBuilder {
        constructor(settings) {
            super(settings);
            this.recommendationSettings = {
                allowFillIfNecessaryToReachNumberOfRecommendations: true,
                allowReplacingOfRecentlyShownRecommendations: true,
                numberOfRecommendations: 10,
                prioritizeDiversityBetweenRequests: false,
            };
        }
        setSelectedContentProperties(contentProperties) {
            this.recommendationSettings.selectedContentProperties = contentProperties;
            return this;
        }
        setNumberOfRecommendations(count) {
            this.recommendationSettings.numberOfRecommendations = count;
            return this;
        }
        allowFillIfNecessaryToReachNumberOfRecommendations(allowed = true) {
            this.recommendationSettings.allowFillIfNecessaryToReachNumberOfRecommendations = allowed;
            return this;
        }
        allowReplacingOfRecentlyShownRecommendations(allowed = true) {
            this.recommendationSettings.allowReplacingOfRecentlyShownRecommendations = allowed;
            return this;
        }
        prioritizeDiversityBetweenRequests(prioritize = true) {
            this.recommendationSettings.prioritizeDiversityBetweenRequests = prioritize;
            return this;
        }
    }

    class ContentsRecommendationCollectionBuilder {
        constructor() {
            this.requests = [];
            this.distinctContentsAcrossResults = true;
        }
        addRequest(request) {
            this.requests.push(request);
            return this;
        }
        requireDistinctContentsAcrossResults(distinctContentsAcrossResults = true) {
            this.distinctContentsAcrossResults = distinctContentsAcrossResults;
            return this;
        }
        build() {
            return {
                $type: 'Relewise.Client.Requests.Recommendations.ContentRecommendationRequestCollection, Relewise.Client',
                requireDistinctContentsAcrossResults: this.distinctContentsAcrossResults,
                requests: this.requests,
            };
        }
    }

    class ContentsViewedAfterViewingContentBuilder extends ContentSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.id = '';
        }
        setContentId(contentId) {
            this.id = contentId;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.ContentsViewedAfterViewingContentRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, contentId: this.id });
            return request;
        }
    }

    class ContentsViewedAfterViewingMultipleContentsBuilder extends ContentSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.ids = [];
        }
        setContentIds(...ids) {
            this.ids = ids;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.ContentsViewedAfterViewingMultipleContentsRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, contentIds: this.ids });
            return request;
        }
    }

    class ContentsViewedAfterViewingMultipleProductsBuilder extends ContentSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.products = [];
        }
        addProduct(product) {
            this.products.push(product);
            return this;
        }
        addProducts(products) {
            products.forEach(x => this.products.push(x));
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.ContentsViewedAfterViewingMultipleProductsRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, productAndVariantIds: this.products });
            return request;
        }
    }

    class ContentsViewedAfterViewingProductBuilder extends ContentSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.productAndVariantId = {
                productId: '',
            };
        }
        product(product) {
            this.productAndVariantId = product;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.ContentsViewedAfterViewingProductRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, productAndVariantId: this.productAndVariantId });
            return request;
        }
    }

    class PersonalContentRecommendationBuilder extends ContentSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PersonalContentRecommendationRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings });
            return request;
        }
    }

    class PopularContentsBuilder extends ContentSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.since = 0;
        }
        sinceMinutesAgo(sinceMinutesAgo) {
            this.since = sinceMinutesAgo;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PopularContentsRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, sinceMinutesAgo: this.since });
            return request;
        }
    }

    class ContentCategoriesRecommendationCollectionBuilder {
        constructor() {
            this.requests = [];
            this.distinctCategoriesAcrossResults = true;
        }
        addRequest(request) {
            this.requests.push(request);
            return this;
        }
        requireDistinctCategoriesAcrossResults(distinctCategoriesAcrossResults = true) {
            this.distinctCategoriesAcrossResults = distinctCategoriesAcrossResults;
            return this;
        }
        build() {
            return {
                $type: 'Relewise.Client.Requests.Recommendations.ContentRecommendationRequestCollection, Relewise.Client',
                requireDistinctCategoriesAcrossResults: this.distinctCategoriesAcrossResults,
                requests: this.requests,
            };
        }
    }

    class ContentCategorySettingsRecommendationBuilder extends RecommendationRequestBuilder {
        constructor(settings) {
            super(settings);
            this.recommendationSettings = {
                allowFillIfNecessaryToReachNumberOfRecommendations: true,
                allowReplacingOfRecentlyShownRecommendations: true,
                numberOfRecommendations: 10,
                prioritizeDiversityBetweenRequests: false,
            };
        }
        setSelectedContentCategoryProperties(ContentCategoryProperties) {
            this.recommendationSettings.selectedContentCategoryProperties = ContentCategoryProperties;
            return this;
        }
        setNumberOfRecommendations(count) {
            this.recommendationSettings.numberOfRecommendations = count;
            return this;
        }
        allowFillIfNecessaryToReachNumberOfRecommendations(allowed = true) {
            this.recommendationSettings.allowFillIfNecessaryToReachNumberOfRecommendations = allowed;
            return this;
        }
        allowReplacingOfRecentlyShownRecommendations(allowed = true) {
            this.recommendationSettings.allowReplacingOfRecentlyShownRecommendations = allowed;
            return this;
        }
        prioritizeDiversityBetweenRequests(prioritize = true) {
            this.recommendationSettings.prioritizeDiversityBetweenRequests = prioritize;
            return this;
        }
    }

    class PersonalContentCategoryRecommendationBuilder extends ContentCategorySettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.since = 0;
            this.weights = { categoryViews: 1.0, contentViews: 1.0 };
        }
        sinceMinutesAgo(sinceMinutesAgo) {
            this.since = sinceMinutesAgo;
            return this;
        }
        setWeights(weights) {
            this.weights = weights;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PersonalContentCategoryRecommendationRequest, Relewise.Client' }, this.baseBuild()), { sinceMinutesAgo: this.since, weights: this.weights, settings: this.recommendationSettings });
            return request;
        }
    }

    class PopularContentCategoriesRecommendationBuilder extends ContentCategorySettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.since = 0;
            this.weights = { categoryViews: 1.0, contentViews: 1.0 };
        }
        sinceMinutesAgo(sinceMinutesAgo) {
            this.since = sinceMinutesAgo;
            return this;
        }
        setWeights(weights) {
            this.weights = weights;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PopularContentCategoriesRecommendationRequest, Relewise.Client' }, this.baseBuild()), { sinceMinutesAgo: this.since, weights: this.weights, settings: this.recommendationSettings });
            return request;
        }
    }

    class BrandSettingsRecommendationBuilder extends RecommendationRequestBuilder {
        constructor(settings) {
            super(settings);
            this.recommendationSettings = {
                allowFillIfNecessaryToReachNumberOfRecommendations: true,
                allowReplacingOfRecentlyShownRecommendations: true,
                numberOfRecommendations: 10,
                prioritizeDiversityBetweenRequests: false,
            };
        }
        setSelectedBrandProperties(brandProperties) {
            this.recommendationSettings.selectedBrandProperties = brandProperties;
            return this;
        }
        setNumberOfRecommendations(count) {
            this.recommendationSettings.numberOfRecommendations = count;
            return this;
        }
        allowFillIfNecessaryToReachNumberOfRecommendations(allowed = true) {
            this.recommendationSettings.allowFillIfNecessaryToReachNumberOfRecommendations = allowed;
            return this;
        }
        allowReplacingOfRecentlyShownRecommendations(allowed = true) {
            this.recommendationSettings.allowReplacingOfRecentlyShownRecommendations = allowed;
            return this;
        }
        prioritizeDiversityBetweenRequests(prioritize = true) {
            this.recommendationSettings.prioritizeDiversityBetweenRequests = prioritize;
            return this;
        }
    }

    class PersonalBrandRecommendationBuilder extends BrandSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.since = 0;
            this.weights = { brandViews: 1.0, productViews: 1.0, productPurchases: 1.0 };
        }
        sinceMinutesAgo(sinceMinutesAgo) {
            this.since = sinceMinutesAgo;
            return this;
        }
        setWeights(weights) {
            this.weights = weights;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PersonalBrandRecommendationRequest, Relewise.Client' }, this.baseBuild()), { sinceMinutesAgo: this.since, weights: this.weights, settings: this.recommendationSettings });
            return request;
        }
    }

    class PopularBrandsRecommendationBuilder extends BrandSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.since = 0;
            this.weights = { brandViews: 1.0, productViews: 1.0, productPurchases: 1.0 };
        }
        sinceMinutesAgo(sinceMinutesAgo) {
            this.since = sinceMinutesAgo;
            return this;
        }
        setWeights(weights) {
            this.weights = weights;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PopularBrandsRecommendationRequest, Relewise.Client' }, this.baseBuild()), { sinceMinutesAgo: this.since, weights: this.weights, settings: this.recommendationSettings });
            return request;
        }
    }

    class ProductCategorySettingsRecommendationBuilder extends RecommendationRequestBuilder {
        constructor(settings) {
            super(settings);
            this.recommendationSettings = {
                allowFillIfNecessaryToReachNumberOfRecommendations: true,
                allowReplacingOfRecentlyShownRecommendations: true,
                numberOfRecommendations: 10,
                prioritizeDiversityBetweenRequests: false,
            };
        }
        setProductCategoryProperties(ProductCategoryProperties) {
            this.recommendationSettings.selectedProductCategoryProperties = ProductCategoryProperties;
            return this;
        }
        setNumberOfRecommendations(count) {
            this.recommendationSettings.numberOfRecommendations = count;
            return this;
        }
        allowFillIfNecessaryToReachNumberOfRecommendations(allowed = true) {
            this.recommendationSettings.allowFillIfNecessaryToReachNumberOfRecommendations = allowed;
            return this;
        }
        allowReplacingOfRecentlyShownRecommendations(allowed = true) {
            this.recommendationSettings.allowReplacingOfRecentlyShownRecommendations = allowed;
            return this;
        }
        prioritizeDiversityBetweenRequests(prioritize = true) {
            this.recommendationSettings.prioritizeDiversityBetweenRequests = prioritize;
            return this;
        }
    }

    class PersonalProductCategoryRecommendationBuilder extends ProductCategorySettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.since = 0;
            this.weights = { categoryViews: 1.0, productViews: 1.0, productPurchases: 1.0 };
        }
        sinceMinutesAgo(sinceMinutesAgo) {
            this.since = sinceMinutesAgo;
            return this;
        }
        setWeights(weights) {
            this.weights = weights;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PersonalProductCategoryRecommendationRequest, Relewise.Client' }, this.baseBuild()), { sinceMinutesAgo: this.since, weights: this.weights, settings: this.recommendationSettings });
            return request;
        }
    }

    class PopularProductCategoriesRecommendationBuilder extends ProductCategorySettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.since = 0;
            this.weights = { categoryViews: 1.0, productViews: 1.0, productPurchases: 1.0 };
        }
        sinceMinutesAgo(sinceMinutesAgo) {
            this.since = sinceMinutesAgo;
            return this;
        }
        setWeights(weights) {
            this.weights = weights;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PopularProductCategoriesRecommendationRequest, Relewise.Client' }, this.baseBuild()), { sinceMinutesAgo: this.since, weights: this.weights, settings: this.recommendationSettings });
            return request;
        }
    }

    class ProductCategoriesRecommendationCollectionBuilder {
        constructor() {
            this.requests = [];
            this.distinctCategoriesAcrossResults = true;
        }
        addRequest(request) {
            this.requests.push(request);
            return this;
        }
        requireDistinctCategoriesAcrossResults(distinctCategoriesAcrossResults = true) {
            this.distinctCategoriesAcrossResults = distinctCategoriesAcrossResults;
            return this;
        }
        build() {
            return {
                $type: 'Relewise.Client.Requests.Recommendations.ProductCategoryRecommendationRequestCollection, Relewise.Client',
                requireDistinctCategoriesAcrossResults: this.distinctCategoriesAcrossResults,
                requests: this.requests,
            };
        }
    }

    class ProductSettingsRecommendationBuilder extends RecommendationRequestBuilder {
        constructor(settings) {
            super(settings);
            this.recommendationSettings = {
                allowFillIfNecessaryToReachNumberOfRecommendations: true,
                allowReplacingOfRecentlyShownRecommendations: true,
                recommendVariant: true,
                numberOfRecommendations: 10,
                prioritizeDiversityBetweenRequests: false,
            };
        }
        setSelectedProductProperties(productProperties) {
            this.recommendationSettings.selectedProductProperties = productProperties;
            return this;
        }
        setSelectedVariantProperties(variantProperties) {
            this.recommendationSettings.selectedVariantProperties = variantProperties;
            return this;
        }
        setSelectedBrandProperties(brandProperties) {
            this.recommendationSettings.selectedBrandProperties = brandProperties;
            return this;
        }
        setNumberOfRecommendations(count) {
            this.recommendationSettings.numberOfRecommendations = count;
            return this;
        }
        allowFillIfNecessaryToReachNumberOfRecommendations(allowed = true) {
            this.recommendationSettings.allowFillIfNecessaryToReachNumberOfRecommendations = allowed;
            return this;
        }
        allowReplacingOfRecentlyShownRecommendations(allowed = true) {
            this.recommendationSettings.allowReplacingOfRecentlyShownRecommendations = allowed;
            return this;
        }
        allowProductsCurrentlyInCart(allowed = true) {
            this.recommendationSettings.allowProductsCurrentlyInCart = allowed;
            return this;
        }
        prioritizeDiversityBetweenRequests(prioritize = true) {
            this.recommendationSettings.prioritizeDiversityBetweenRequests = prioritize;
            return this;
        }
        recommendVariant(recommend = true) {
            this.recommendationSettings.recommendVariant = recommend;
            return this;
        }
    }

    class PurchasedWithCurrentCartBuilder extends ProductSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PurchasedWithCurrentCartRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings });
            return request;
        }
    }

    class BySingleProductRecommendationBuilder extends ProductSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.productAndVariantId = null;
        }
        product(product) {
            this.productAndVariantId = product;
            return this;
        }
    }

    class ProductsViewedAfterViewingProductBuilder extends BySingleProductRecommendationBuilder {
        constructor(settings) {
            super(settings);
        }
        build() {
            if (this.productAndVariantId === null) {
                throw new Error('Must specificy a product');
            }
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.ProductsViewedAfterViewingProductRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, productAndVariantId: this.productAndVariantId });
            return request;
        }
    }

    class ProductsViewedAfterViewingContentBuilder extends ProductSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.id = '';
        }
        setContentId(contentId) {
            this.id = contentId;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.ProductsViewedAfterViewingContentRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, contentId: this.id });
            return request;
        }
    }

    class PersonalProductRecommendationBuilder extends ProductSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PersonalProductRecommendationRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings });
            return request;
        }
    }

    class PopularProductsBuilder extends ProductSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.since = 0;
            this.basedOnSelection = 'MostPurchased';
        }
        basedOn(basedOn) {
            this.basedOnSelection = basedOn;
            return this;
        }
        sinceMinutesAgo(sinceMinutesAgo) {
            this.since = sinceMinutesAgo;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PopularProductsRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, basedOn: this.basedOnSelection, sinceMinutesAgo: this.since });
            return request;
        }
    }

    class RecentlyViewedProductsBuilder extends ProductSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.RecentlyViewedProductsRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings });
            return request;
        }
    }

    class SortVariantsBuilder extends ProductSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.id = '';
        }
        setProductId(productId) {
            this.id = productId;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.SortVariantsRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, productId: this.id });
            return request;
        }
    }

    class ProductsRecommendationCollectionBuilder {
        constructor() {
            this.requests = [];
            this.distinctProductsAcrossResults = true;
        }
        addRequest(request) {
            this.requests.push(request);
            return this;
        }
        requireDistinctProductsAcrossResults(distinctProductsAcrossResults = true) {
            this.distinctProductsAcrossResults = distinctProductsAcrossResults;
            return this;
        }
        build() {
            return {
                $type: 'Relewise.Client.Requests.Recommendations.ProductRecommendationRequestCollection, Relewise.Client',
                requireDistinctProductsAcrossResults: this.distinctProductsAcrossResults,
                requests: this.requests,
            };
        }
    }

    class PurchasedWithMultipleProductsBuilder extends ProductSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.products = [];
        }
        addProduct(product) {
            this.products.push(product);
            return this;
        }
        addProducts(products) {
            products.forEach(x => this.products.push(x));
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PurchasedWithMultipleProductsRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, productAndVariantIds: this.products });
            return request;
        }
    }

    class PurchasedWithProductBuilder extends BySingleProductRecommendationBuilder {
        constructor(settings) {
            super(settings);
        }
        build() {
            if (this.productAndVariantId === null) {
                throw new Error('Must specificy a product');
            }
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PurchasedWithProductRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, productAndVariantId: this.productAndVariantId });
            return request;
        }
    }

    class SearchTermBasedProductRecommendationBuilder extends ProductSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.term = '';
        }
        setTerm(term) {
            this.term = term;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.SearchTermBasedProductRecommendationRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, term: this.term });
            return request;
        }
    }

    class SortProductsBuilder extends ProductSettingsRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.ids = [];
        }
        setProductIds(productIds) {
            this.ids = productIds;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.SortProductsRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, productIds: this.ids });
            return request;
        }
    }

    class SimilarProductsProductBuilder extends BySingleProductRecommendationBuilder {
        constructor(settings) {
            super(settings);
            this.evaluationSettings = null;
            this.considerAlreadyKnownInformationAboutProduct = false;
            this.productData = null;
        }
        setSimilarProductsEvaluationSettings(settings) {
            this.evaluationSettings = settings;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.SimilarProductsRequest, Relewise.Client' }, this.baseBuild()), { settings: this.recommendationSettings, existingProductId: this.productAndVariantId, considerAlreadyKnownInformationAboutProduct: this.considerAlreadyKnownInformationAboutProduct, productData: this.productData, evaluationSettings: this.evaluationSettings });
            return request;
        }
    }

    class PopularSearchTermsRecommendationBuilder extends RecommendationRequestBuilder {
        constructor(settings) {
            super(settings);
            this.recommendationSettings = {
                numberOfRecommendations: 10,
            };
        }
        setTerm(term) {
            this.term = term;
            return this;
        }
        addEntityType(...types) {
            this.recommendationSettings.targetEntityTypes = types;
            return this;
        }
        build() {
            const request = Object.assign(Object.assign({ $type: 'Relewise.Client.Requests.Recommendations.PopularSearchTermsRecommendationRequest, Relewise.Client' }, this.baseBuild()), { term: this.term, settings: this.recommendationSettings });
            return request;
        }
    }

    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    var version = { tag: '1.14.0' };

    class RelewiseClient {
        constructor(datasetId, apiKey, options) {
            this.datasetId = datasetId;
            this.apiKey = apiKey;
            this._serverUrl = 'https://api.relewise.com';
            this._urlPath = 'v1';
            if (!datasetId)
                throw new Error('Dataset id cannot be null or empty. Please contact Relewise if you don\'t have an account already or would like a free demo license');
            if (!apiKey)
                throw new Error('API Key secret cannot be null or empty. Please contact Relewise support if you don\'t know the apiKeySecret for your datasetId.');
            if (options === null || options === void 0 ? void 0 : options.serverUrl) {
                this._serverUrl = options.serverUrl;
            }
        }
        get serverUrl() {
            return this._serverUrl;
        }
        request(name, data) {
            return __awaiter(this, void 0, void 0, function* () {
                const apiKeyHeader = `APIKey ${this.apiKey}`;
                const requestUrl = this.createRequestUrl(this._serverUrl, this.datasetId, this._urlPath, name);
                const response = yield fetch__default["default"](requestUrl, {
                    method: 'POST',
                    headers: {
                        Authorization: apiKeyHeader,
                        'Content-Type': 'application/json',
                        'X-Relewise-Version': version.tag,
                    },
                    body: JSON.stringify(data),
                });
                try {
                    return yield response.json();
                }
                catch (err) {
                    return undefined;
                }
            });
        }
        createRequestUrl(baseUrl, ...segments) {
            const joinedSegments = segments.join('/');
            return baseUrl.endsWith('/')
                ? baseUrl.concat(joinedSegments)
                : baseUrl.concat('/', joinedSegments);
        }
    }

    class Tracker extends RelewiseClient {
        constructor(datasetId, apiKey, options) {
            super(datasetId, apiKey, options);
            this.datasetId = datasetId;
            this.apiKey = apiKey;
        }
        trackOrder({ user, subtotal, orderNumber, lineItems, cartName = 'default', trackingNumber }) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('TrackOrderRequest', {
                    $type: 'Relewise.Client.Requests.Tracking.TrackOrderRequest, Relewise.Client',
                    order: {
                        $type: 'Relewise.Client.DataTypes.Order, Relewise.Client',
                        lineItems: lineItems.map(l => (Object.assign(Object.assign({ product: {
                                id: l.productId,
                            } }, (l.variantId && { variant: { id: l.variantId } })), { lineTotal: l.lineTotal, quantity: l.quantity }))),
                        subtotal: { amount: subtotal.amount, currency: { value: subtotal.currency } },
                        orderNumber: orderNumber,
                        trackingNumber: trackingNumber,
                        cartName: cartName,
                        user: user,
                    },
                });
            });
        }
        trackCart({ user, subtotal, lineItems, cartName = 'default' }) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('TrackCartRequest', {
                    $type: 'Relewise.Client.Requests.Tracking.TrackCartRequest, Relewise.Client',
                    cart: {
                        $type: 'Relewise.Client.DataTypes.Cart, Relewise.Client',
                        lineItems: lineItems.map(l => (Object.assign(Object.assign({ product: {
                                id: l.productId,
                            } }, (l.variantId && { variant: { id: l.variantId } })), { lineTotal: l.lineTotal, quantity: l.quantity }))),
                        subtotal: { amount: subtotal.amount, currency: { value: subtotal.currency } },
                        name: cartName,
                        user: user,
                    },
                });
            });
        }
        trackProductView({ productId, variantId, user }) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('TrackProductViewRequest', {
                    $type: 'Relewise.Client.Requests.Tracking.TrackProductViewRequest, Relewise.Client',
                    productView: Object.assign(Object.assign({ $type: 'Relewise.Client.DataTypes.ProductView, Relewise.Client', product: {
                            id: productId,
                        } }, (variantId && { variant: { id: variantId } })), { user: user }),
                });
            });
        }
        trackProductCategoryView({ idPath, user }) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('TrackProductCategoryViewRequest', {
                    $type: 'Relewise.Client.Requests.Tracking.TrackProductCategoryViewRequest, Relewise.Client',
                    productCategoryView: {
                        $type: 'Relewise.Client.DataTypes.ProductCategoryView, Relewise.Client',
                        idPath: idPath,
                        user: user,
                    },
                });
            });
        }
        trackContentView({ contentId, user }) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('TrackContentViewRequest', {
                    $type: 'Relewise.Client.Requests.Tracking.TrackContentViewRequest, Relewise.Client',
                    contentView: {
                        $type: 'Relewise.Client.DataTypes.ContentView, Relewise.Client',
                        content: {
                            id: contentId,
                        },
                        user: user,
                    },
                });
            });
        }
        trackContentCategoryView({ idPath, user }) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('TrackContentCategoryViewRequest', {
                    $type: 'Relewise.Client.Requests.Tracking.TrackContentCategoryViewRequest, Relewise.Client',
                    contentCategoryView: {
                        $type: 'Relewise.Client.DataTypes.ContentCategoryView, Relewise.Client',
                        idPath: idPath,
                        user: user,
                    },
                });
            });
        }
        trackBrandView({ brandId, user }) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('TrackBrandViewRequest', {
                    $type: 'Relewise.Client.Requests.Tracking.TrackBrandViewRequest, Relewise.Client',
                    brandView: {
                        $type: 'Relewise.Client.DataTypes.BrandView, Relewise.Client',
                        brand: {
                            id: brandId,
                        },
                        user: user,
                    },
                });
            });
        }
        trackSearchTerm({ term, language, user }) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('TrackSearchTermRequest', {
                    $type: 'Relewise.Client.Requests.Tracking.TrackSearchTermRequest, Relewise.Client',
                    searchTerm: {
                        $type: 'Relewise.Client.DataTypes.SearchTerm, Relewise.Client',
                        language: {
                            value: language,
                        },
                        term: term,
                        user: user,
                    },
                });
            });
        }
        trackUserUpdate({ user, updateKind = 'UpdateAndAppend' }) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('TrackUserUpdateRequest', {
                    $type: 'Relewise.Client.Requests.Tracking.TrackUserUpdateRequest, Relewise.Client',
                    userUpdate: {
                        $type: 'Relewise.Client.DataTypes.UserUpdate, Relewise.Client',
                        user: user,
                        kind: updateKind,
                    },
                });
            });
        }
    }

    class Searcher extends RelewiseClient {
        constructor(datasetId, apiKey, options) {
            super(datasetId, apiKey, options);
            this.datasetId = datasetId;
            this.apiKey = apiKey;
        }
        searchProducts(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ProductSearchRequest', request);
            });
        }
        searchProductCategories(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ProductCategorySearchRequest', request);
            });
        }
        searchContents(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ContentSearchRequest', request);
            });
        }
        searchTermPrediction(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('SearchTermPredictionRequest', request);
            });
        }
        batch(requestCollections) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('SearchRequestCollection', requestCollections);
            });
        }
    }

    class Recommender extends RelewiseClient {
        constructor(datasetId, apiKey, options) {
            super(datasetId, apiKey, options);
            this.datasetId = datasetId;
            this.apiKey = apiKey;
        }
        recommendPopularSearchTerms(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PopularSearchTermsRecommendationRequest', request);
            });
        }
        //#region Brands
        recommendPersonalBrands(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PersonalBrandRecommendationRequest', request);
            });
        }
        recommendPopularBrands(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PopularBrandsRecommendationRequest', request);
            });
        }
        //#endregion
        //#region Content Categories
        recommendPersonalContentCategories(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PersonalContentCategoryRecommendationRequest', request);
            });
        }
        recommendPopularContentCategories(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PopularContentCategoriesRecommendationRequest', request);
            });
        }
        //#endregion
        //#region Product Categories
        recommendPersonalProductCategories(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PersonalProductCategoryRecommendationRequest', request);
            });
        }
        recommendPopularProductCategories(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PopularProductCategoriesRecommendationRequest', request);
            });
        }
        //#endregion
        //#region Products
        recommendPurchasedWithProduct(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PurchasedWithProductRequest', request);
            });
        }
        recommendPurchasedWithMultipleProducts(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PurchasedWithMultipleProductsRequest', request);
            });
        }
        sortVariants(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('SortVariantsRequest', request);
            });
        }
        sortProducts(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('SortProductsRequest', request);
            });
        }
        recommendSimilarProducts(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('SimilarProductsRequest', request);
            });
        }
        recommendSearchTermBasedProducts(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('SearchTermBasedProductRecommendationRequest', request);
            });
        }
        recentlyViewedProducts(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('RecentlyViewedProductsRequest', request);
            });
        }
        recommendPurchasedWithCurrentCart(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PurchasedWithCurrentCartRequest', request);
            });
        }
        recommendProductsViewedAfterViewingProduct(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ProductsViewedAfterViewingProductRequest', request);
            });
        }
        recommendProductsViewedAfterViewingContent(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ProductsViewedAfterViewingContentRequest', request);
            });
        }
        recommendPopularProducts(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PopularProductsRequest', request);
            });
        }
        recommendPersonalProducts(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PersonalProductRecommendationRequest', request);
            });
        }
        //#endregion
        //#region Content
        recommendPopularContents(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PopularContentsRequest', request);
            });
        }
        recommendPersonalContents(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('PopularContentsRequest', request);
            });
        }
        recommendContentsViewedAfterViewingProduct(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ContentsViewedAfterViewingProductRequest', request);
            });
        }
        recommendContentsViewedAfterViewingMultipleProducts(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ContentsViewedAfterViewingProductRequest', request);
            });
        }
        recommendContentsViewedAfterViewingMultipleContents(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ContentsViewedAfterViewingMultipleContentsRequest', request);
            });
        }
        recommendContentsViewedAfterViewingContent(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ContentsViewedAfterViewingContentRequest', request);
            });
        }
        //#endregion
        //#region Batching 
        batchProductRecommendations(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ProductRecommendationRequestCollection', request);
            });
        }
        batchContentRecommendations(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ContentRecommendationRequestCollection', request);
            });
        }
        batchContentCategoryRecommendations(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ContentCategoryRecommendationRequestCollection', request);
            });
        }
        batchProductCategoryRecommendations(request) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.request('ProductCategoryRecommendationRequestCollection', request);
            });
        }
    }

    class UserFactory {
        static anonymous(user) {
            return Object.assign({}, user);
        }
        static byAuthenticatedId(authenticatedId, temporaryId, user) {
            return Object.assign(Object.assign({ authenticatedId }, (temporaryId && { temporaryId })), user);
        }
        static byTemporaryId(temporaryId, user) {
            return Object.assign(Object.assign({}, user), { temporaryId });
        }
        static byIdentifier(key, value, user) {
            return Object.assign(Object.assign({}, user), { identifiers: { [key]: value } });
        }
        static byIdentifiers(identifiers, user) {
            return Object.assign({ identifiers }, user);
        }
        static byEmail(email, user) {
            return Object.assign({ email }, user);
        }
        static byFingerprint(fingerprint, user) {
            return Object.assign({ fingerprint }, user);
        }
    }

    class DataValueFactory {
        static string(value) {
            return new StringDataValue(value);
        }
        static stringCollection(collection) {
            return new StringCollectionDataValue(collection);
        }
        static number(value) {
            return new NumberDataValue(value);
        }
        static doubleCollection(collection) {
            return new DoubleCollectionDataValue(collection);
        }
        static boolean(value) {
            return new BooleanDataValue(value);
        }
        static booleanCollection(collection) {
            return new BooleanCollectionDataValue(collection);
        }
        static multiCurrency(values) {
            return new MultiCurrencyDataValue(values);
        }
        static multilingual(values) {
            return new MultilingualDataValue(values);
        }
        static multilingualCollection(values) {
            return new MultilingualCollectionDataValue(values);
        }
        static object(data) {
            return new ObjectDataValue(data);
        }
        static objectCollection(objects) {
            return new ObjectCollectionDataValue(objects);
        }
    }

    class ValueSelectorFactory {
        static dataDoubleSelector(key) {
            return {
                $type: 'Relewise.Client.Requests.ValueSelectors.DataDoubleSelector, Relewise.Client',
                key: key,
            };
        }
        static fixedDoubleValueSelector(value) {
            return {
                $type: 'Relewise.Client.Requests.ValueSelectors.FixedDoubleValueSelector, Relewise.Client',
                value: value,
            };
        }
    }

    exports.BooleanCollectionDataValue = BooleanCollectionDataValue;
    exports.BooleanDataValue = BooleanDataValue;
    exports.BrandSettingsRecommendationBuilder = BrandSettingsRecommendationBuilder;
    exports.BySingleProductRecommendationBuilder = BySingleProductRecommendationBuilder;
    exports.ConditionBuilder = ConditionBuilder;
    exports.ContentCategoriesRecommendationCollectionBuilder = ContentCategoriesRecommendationCollectionBuilder;
    exports.ContentCategorySettingsRecommendationBuilder = ContentCategorySettingsRecommendationBuilder;
    exports.ContentSearchBuilder = ContentSearchBuilder;
    exports.ContentSettingsRecommendationBuilder = ContentSettingsRecommendationBuilder;
    exports.ContentSortingBuilder = ContentSortingBuilder;
    exports.ContentsRecommendationCollectionBuilder = ContentsRecommendationCollectionBuilder;
    exports.ContentsViewedAfterViewingContentBuilder = ContentsViewedAfterViewingContentBuilder;
    exports.ContentsViewedAfterViewingMultipleContentsBuilder = ContentsViewedAfterViewingMultipleContentsBuilder;
    exports.ContentsViewedAfterViewingMultipleProductsBuilder = ContentsViewedAfterViewingMultipleProductsBuilder;
    exports.ContentsViewedAfterViewingProductBuilder = ContentsViewedAfterViewingProductBuilder;
    exports.DataObjectFacetBuilder = DataObjectFacetBuilder;
    exports.DataObjectFilterConditionBuilder = DataObjectFilterConditionBuilder;
    exports.DataValueBase = DataValueBase;
    exports.DataValueFactory = DataValueFactory;
    exports.DoubleCollectionDataValue = DoubleCollectionDataValue;
    exports.FacetBuilder = FacetBuilder;
    exports.FilterBuilder = FilterBuilder;
    exports.MultiCurrencyDataValue = MultiCurrencyDataValue;
    exports.MultilingualCollectionDataValue = MultilingualCollectionDataValue;
    exports.MultilingualDataValue = MultilingualDataValue;
    exports.NumberDataValue = NumberDataValue;
    exports.ObjectCollectionDataValue = ObjectCollectionDataValue;
    exports.ObjectDataValue = ObjectDataValue;
    exports.PaginationBuilder = PaginationBuilder;
    exports.PersonalBrandRecommendationBuilder = PersonalBrandRecommendationBuilder;
    exports.PersonalContentCategoryRecommendationBuilder = PersonalContentCategoryRecommendationBuilder;
    exports.PersonalContentRecommendationBuilder = PersonalContentRecommendationBuilder;
    exports.PersonalProductCategoryRecommendationBuilder = PersonalProductCategoryRecommendationBuilder;
    exports.PersonalProductRecommendationBuilder = PersonalProductRecommendationBuilder;
    exports.PopularBrandsRecommendationBuilder = PopularBrandsRecommendationBuilder;
    exports.PopularContentCategoriesRecommendationBuilder = PopularContentCategoriesRecommendationBuilder;
    exports.PopularContentsBuilder = PopularContentsBuilder;
    exports.PopularProductCategoriesRecommendationBuilder = PopularProductCategoriesRecommendationBuilder;
    exports.PopularProductsBuilder = PopularProductsBuilder;
    exports.PopularSearchTermsRecommendationBuilder = PopularSearchTermsRecommendationBuilder;
    exports.ProductCategoriesRecommendationCollectionBuilder = ProductCategoriesRecommendationCollectionBuilder;
    exports.ProductCategorySearchBuilder = ProductCategorySearchBuilder;
    exports.ProductCategorySettingsRecommendationBuilder = ProductCategorySettingsRecommendationBuilder;
    exports.ProductCategorySortingBuilder = ProductCategorySortingBuilder;
    exports.ProductSearchBuilder = ProductSearchBuilder;
    exports.ProductSettingsRecommendationBuilder = ProductSettingsRecommendationBuilder;
    exports.ProductSortingBuilder = ProductSortingBuilder;
    exports.ProductsRecommendationCollectionBuilder = ProductsRecommendationCollectionBuilder;
    exports.ProductsViewedAfterViewingContentBuilder = ProductsViewedAfterViewingContentBuilder;
    exports.ProductsViewedAfterViewingProductBuilder = ProductsViewedAfterViewingProductBuilder;
    exports.PurchasedWithCurrentCartBuilder = PurchasedWithCurrentCartBuilder;
    exports.PurchasedWithMultipleProductsBuilder = PurchasedWithMultipleProductsBuilder;
    exports.PurchasedWithProductBuilder = PurchasedWithProductBuilder;
    exports.RecentlyViewedProductsBuilder = RecentlyViewedProductsBuilder;
    exports.RecommendationRequestBuilder = RecommendationRequestBuilder;
    exports.Recommender = Recommender;
    exports.RelevanceModifierBuilder = RelevanceModifierBuilder;
    exports.RelewiseClient = RelewiseClient;
    exports.SearchCollectionBuilder = SearchCollectionBuilder;
    exports.SearchRequestBuilder = SearchRequestBuilder;
    exports.SearchTermBasedProductRecommendationBuilder = SearchTermBasedProductRecommendationBuilder;
    exports.SearchTermPredictionBuilder = SearchTermPredictionBuilder;
    exports.Searcher = Searcher;
    exports.SimilarProductsProductBuilder = SimilarProductsProductBuilder;
    exports.SortProductsBuilder = SortProductsBuilder;
    exports.SortVariantsBuilder = SortVariantsBuilder;
    exports.StringCollectionDataValue = StringCollectionDataValue;
    exports.StringDataValue = StringDataValue;
    exports.Tracker = Tracker;
    exports.UserFactory = UserFactory;
    exports.ValueSelectorFactory = ValueSelectorFactory;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=relewise-client.js.map


/***/ }),

/***/ 79519:
/***/ (function(module, exports) {

var global = typeof self !== 'undefined' ? self : this;
var __self__ = (function () {
function F() {
this.fetch = false;
this.DOMException = global.DOMException
}
F.prototype = global;
return new F();
})();
(function(self) {

var irrelevant = (function (exports) {

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = self.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new exports.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  Object.defineProperty(exports, '__esModule', { value: true });

  return exports;

})({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
exports["default"] = ctx.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers
exports.Request = ctx.Request
exports.Response = ctx.Response
module.exports = exports


/***/ }),

/***/ 77626:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
(function(){var e={477:function(e){"use strict";e.exports=__webpack_require__(3048)}};var t={};function __nccwpck_require__(o){var a=t[o];if(a!==undefined){return a.exports}var s=t[o]={exports:{}};var n=true;try{e[o](s,s.exports,__nccwpck_require__);n=false}finally{if(n)delete t[o]}return s.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var o={};!function(){var e=o;var t,a=(t=__nccwpck_require__(477))&&"object"==typeof t&&"default"in t?t.default:t,s=/https?|ftp|gopher|file/;function r(e){"string"==typeof e&&(e=d(e));var t=function(e,t,o){var a=e.auth,s=e.hostname,n=e.protocol||"",p=e.pathname||"",c=e.hash||"",i=e.query||"",u=!1;a=a?encodeURIComponent(a).replace(/%3A/i,":")+"@":"",e.host?u=a+e.host:s&&(u=a+(~s.indexOf(":")?"["+s+"]":s),e.port&&(u+=":"+e.port)),i&&"object"==typeof i&&(i=t.encode(i));var f=e.search||i&&"?"+i||"";return n&&":"!==n.substr(-1)&&(n+=":"),e.slashes||(!n||o.test(n))&&!1!==u?(u="//"+(u||""),p&&"/"!==p[0]&&(p="/"+p)):u||(u=""),c&&"#"!==c[0]&&(c="#"+c),f&&"?"!==f[0]&&(f="?"+f),{protocol:n,host:u,pathname:p=p.replace(/[?#]/g,encodeURIComponent),search:f=f.replace("#","%23"),hash:c}}(e,a,s);return""+t.protocol+t.host+t.pathname+t.search+t.hash}var n="http://",p="w.w",c=n+p,i=/^([a-z0-9.+-]*:\/\/\/)([a-z0-9.+-]:\/*)?/i,u=/https?|ftp|gopher|file/;function h(e,t){var o="string"==typeof e?d(e):e;e="object"==typeof e?r(e):e;var a=d(t),s="";o.protocol&&!o.slashes&&(s=o.protocol,e=e.replace(o.protocol,""),s+="/"===t[0]||"/"===e[0]?"/":""),s&&a.protocol&&(s="",a.slashes||(s=a.protocol,t=t.replace(a.protocol,"")));var p=e.match(i);p&&!a.protocol&&(e=e.substr((s=p[1]+(p[2]||"")).length),/^\/\/[^/]/.test(t)&&(s=s.slice(0,-1)));var f=new URL(e,c+"/"),m=new URL(t,f).toString().replace(c,""),v=a.protocol||o.protocol;return v+=o.slashes||a.slashes?"//":"",!s&&v?m=m.replace(n,v):s&&(m=m.replace(n,"")),u.test(m)||~t.indexOf(".")||"/"===e.slice(-1)||"/"===t.slice(-1)||"/"!==m.slice(-1)||(m=m.slice(0,-1)),s&&(m=s+("/"===m[0]?m.substr(1):m)),m}function l(){}l.prototype.parse=d,l.prototype.format=r,l.prototype.resolve=h,l.prototype.resolveObject=h;var f=/^https?|ftp|gopher|file/,m=/^(.*?)([#?].*)/,v=/^([a-z0-9.+-]*:)(\/{0,3})(.*)/i,_=/^([a-z0-9.+-]*:)?\/\/\/*/i,b=/^([a-z0-9.+-]*:)(\/{0,2})\[(.*)\]$/i;function d(e,t,o){if(void 0===t&&(t=!1),void 0===o&&(o=!1),e&&"object"==typeof e&&e instanceof l)return e;var s=(e=e.trim()).match(m);e=s?s[1].replace(/\\/g,"/")+s[2]:e.replace(/\\/g,"/"),b.test(e)&&"/"!==e.slice(-1)&&(e+="/");var n=!/(^javascript)/.test(e)&&e.match(v),i=_.test(e),u="";n&&(f.test(n[1])||(u=n[1].toLowerCase(),e=""+n[2]+n[3]),n[2]||(i=!1,f.test(n[1])?(u=n[1],e=""+n[3]):e="//"+n[3]),3!==n[2].length&&1!==n[2].length||(u=n[1],e="/"+n[3]));var g,y=(s?s[1]:e).match(/^https?:\/\/[^/]+(:[0-9]+)(?=\/|$)/),w=y&&y[1],C=new l,U="",j="";try{g=new URL(e)}catch(t){U=t,u||o||!/^\/\//.test(e)||/^\/\/.+[@.]/.test(e)||(j="/",e=e.substr(1));try{g=new URL(e,c)}catch(e){return C.protocol=u,C.href=u,C}}C.slashes=i&&!j,C.host=g.host===p?"":g.host,C.hostname=g.hostname===p?"":g.hostname.replace(/(\[|\])/g,""),C.protocol=U?u||null:g.protocol,C.search=g.search.replace(/\\/g,"%5C"),C.hash=g.hash.replace(/\\/g,"%5C");var x=e.split("#");!C.search&&~x[0].indexOf("?")&&(C.search="?"),C.hash||""!==x[1]||(C.hash="#"),C.query=t?a.decode(g.search.substr(1)):C.search.substr(1),C.pathname=j+(n?function(e){return e.replace(/['^|`]/g,(function(e){return"%"+e.charCodeAt().toString(16).toUpperCase()})).replace(/((?:%[0-9A-F]{2})+)/g,(function(e,t){try{return decodeURIComponent(t).split("").map((function(e){var t=e.charCodeAt();return t>256||/^[a-z0-9]$/i.test(e)?e:"%"+t.toString(16).toUpperCase()})).join("")}catch(e){return t}}))}(g.pathname):g.pathname),"about:"===C.protocol&&"blank"===C.pathname&&(C.protocol="",C.pathname=""),U&&"/"!==e[0]&&(C.pathname=C.pathname.substr(1)),u&&!f.test(u)&&"/"!==e.slice(-1)&&"/"===C.pathname&&(C.pathname=""),C.path=C.pathname+C.search,C.auth=[g.username,g.password].map(decodeURIComponent).filter(Boolean).join(":"),C.port=g.port,w&&!C.host.endsWith(w)&&(C.host+=w,C.port=w.slice(1)),C.href=j?""+C.pathname+C.search+C.hash:r(C);var q=/^(file)/.test(C.href)?["host","hostname"]:[];return Object.keys(C).forEach((function(e){~q.indexOf(e)||(C[e]=C[e]||null)})),C}e.parse=d,e.format=r,e.resolve=h,e.resolveObject=function(e,t){return d(h(e,t))},e.Url=l}();module.exports=o})();

/***/ }),

/***/ 12246:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(73360)


/***/ }),

/***/ 24400:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};


/***/ }),

/***/ 7433:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).map(function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};


/***/ }),

/***/ 3048:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(24400);
exports.encode = exports.stringify = __webpack_require__(7433);


/***/ }),

/***/ 71081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _misc_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88390);


var useSessionStorage = function (key, initialValue, raw) {
    if (!_misc_util__WEBPACK_IMPORTED_MODULE_1__/* .isBrowser */ .jU) {
        return [initialValue, function () { }];
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
        try {
            var sessionStorageValue = sessionStorage.getItem(key);
            if (typeof sessionStorageValue !== 'string') {
                sessionStorage.setItem(key, raw ? String(initialValue) : JSON.stringify(initialValue));
                return initialValue;
            }
            else {
                return raw ? sessionStorageValue : JSON.parse(sessionStorageValue || 'null');
            }
        }
        catch (_a) {
            // If user is in private mode or has storage restriction
            // sessionStorage can throw. JSON.parse and JSON.stringify
            // can throw, too.
            return initialValue;
        }
    }), state = _a[0], setState = _a[1];
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        try {
            var serializedState = raw ? String(state) : JSON.stringify(state);
            sessionStorage.setItem(key, serializedState);
        }
        catch (_a) {
            // If user is in private mode or has storage restriction
            // sessionStorage can throw. Also JSON.stringify can throw.
        }
    });
    return [state, setState];
};
/* harmony default export */ __webpack_exports__["Z"] = (useSessionStorage);


/***/ }),

/***/ 2924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ o; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react-hook-form@7.39.7_react@18.2.0/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(40505);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@hookform+resolvers@2.9.11_react-hook-form@7.39.7/node_modules/@hookform/resolvers/dist/resolvers.mjs
var e=function(i,e,t){if(i&&"reportValidity"in i){var f=(0,index_esm/* get */.U2)(t,e);i.setCustomValidity(f&&f.message||""),i.reportValidity()}},resolvers_t=function(r,i){var t=function(t){var f=i.fields[t];f&&f.ref&&"reportValidity"in f.ref?e(f.ref,t,r):f.refs&&f.refs.forEach(function(i){return e(i,t,r)})};for(var f in i.fields)t(f)},f=function(e,f){f.shouldUseNativeValidation&&resolvers_t(e,f);var o={};for(var a in e){var n=(0,index_esm/* get */.U2)(f.fields,a);(0,index_esm/* set */.t8)(o,a,Object.assign(e[a],{ref:n&&n.ref}))}return o};
//# sourceMappingURL=resolvers.module.js.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@hookform+resolvers@2.9.11_react-hook-form@7.39.7/node_modules/@hookform/resolvers/yup/dist/yup.mjs
var o=function(o,n,a){return void 0===n&&(n={}),void 0===a&&(a={}),function(s,i,c){try{return Promise.resolve(function(t,r){try{var u=(n.context&&"development"==="production"&&0,Promise.resolve(o["sync"===a.mode?"validateSync":"validate"](s,Object.assign({abortEarly:!1},n,{context:i}))).then(function(t){return c.shouldUseNativeValidation&&resolvers_t({},c),{values:a.rawValues?s:t,errors:{}}}))}catch(e){return r(e)}return u&&u.then?u.then(void 0,r):u}(0,function(e){if(!e.inner)throw e;return{values:{},errors:f((o=e,n=!c.shouldUseNativeValidation&&"all"===c.criteriaMode,(o.inner||[]).reduce(function(e,t){if(e[t.path]||(e[t.path]={message:t.message,type:t.type}),n){var o=e[t.path].types,a=o&&o[t.type];e[t.path]=(0,index_esm/* appendErrors */.KN)(t.path,n,e,t.type,a?[].concat(a,t.message):t.message)}return e},{})),c)};var o,n}))}catch(e){return Promise.reject(e)}}};
//# sourceMappingURL=yup.module.js.map


/***/ }),

/***/ 60750:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ useInfiniteQuery; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+query-core@4.10.3/node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(82221);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+query-core@4.10.3/node_modules/@tanstack/query-core/build/lib/queryObserver.mjs
var queryObserver = __webpack_require__(25280);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+query-core@4.10.3/node_modules/@tanstack/query-core/build/lib/infiniteQueryBehavior.mjs
var infiniteQueryBehavior = __webpack_require__(81030);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tanstack+query-core@4.10.3/node_modules/@tanstack/query-core/build/lib/infiniteQueryObserver.mjs



class InfiniteQueryObserver extends queryObserver/* QueryObserver */.z {
  // Type override
  // Type override
  // Type override
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(client, options) {
    super(client, options);
  }

  bindMethods() {
    super.bindMethods();
    this.fetchNextPage = this.fetchNextPage.bind(this);
    this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  }

  setOptions(options, notifyOptions) {
    super.setOptions({ ...options,
      behavior: (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)()
    }, notifyOptions);
  }

  getOptimisticResult(options) {
    options.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return super.getOptimisticResult(options);
  }

  fetchNextPage({
    pageParam,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        fetchMore: {
          direction: 'forward',
          pageParam
        }
      }
    });
  }

  fetchPreviousPage({
    pageParam,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        fetchMore: {
          direction: 'backward',
          pageParam
        }
      }
    });
  }

  createResult(query, options) {
    var _state$data, _state$data2, _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet;

    const {
      state
    } = query;
    const result = super.createResult(query, options);
    return { ...result,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: (0,infiniteQueryBehavior/* hasNextPage */.Qy)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
      hasPreviousPage: (0,infiniteQueryBehavior/* hasPreviousPage */.ZF)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
      isFetchingNextPage: state.fetchStatus === 'fetching' && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward',
      isFetchingPreviousPage: state.fetchStatus === 'fetching' && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward'
    };
  }

}


//# sourceMappingURL=infiniteQueryObserver.mjs.map

// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.10.3_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/lib/useBaseQuery.mjs + 3 modules
var useBaseQuery = __webpack_require__(79057);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.10.3_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs



function useInfiniteQuery(arg1, arg2, arg3) {
  const options = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return (0,useBaseQuery/* useBaseQuery */.r)(options, InfiniteQueryObserver);
}


//# sourceMappingURL=useInfiniteQuery.mjs.map


/***/ }),

/***/ 53083:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ useMutation; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.10.3_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/lib/useSyncExternalStore.mjs
var useSyncExternalStore = __webpack_require__(39414);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+query-core@4.10.3/node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(82221);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+query-core@4.10.3/node_modules/@tanstack/query-core/build/lib/mutation.mjs
var mutation = __webpack_require__(28137);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+query-core@4.10.3/node_modules/@tanstack/query-core/build/lib/notifyManager.mjs
var notifyManager = __webpack_require__(22534);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+query-core@4.10.3/node_modules/@tanstack/query-core/build/lib/subscribable.mjs
var subscribable = __webpack_require__(34360);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tanstack+query-core@4.10.3/node_modules/@tanstack/query-core/build/lib/mutationObserver.mjs





// CLASS
class MutationObserver extends subscribable/* Subscribable */.l {
  constructor(client, options) {
    super();
    this.client = client;
    this.setOptions(options);
    this.bindMethods();
    this.updateResult();
  }

  bindMethods() {
    this.mutate = this.mutate.bind(this);
    this.reset = this.reset.bind(this);
  }

  setOptions(options) {
    const prevOptions = this.options;
    this.options = this.client.defaultMutationOptions(options);

    if (!(0,utils/* shallowEqualObjects */.VS)(prevOptions, this.options)) {
      this.client.getMutationCache().notify({
        type: 'observerOptionsUpdated',
        mutation: this.currentMutation,
        observer: this
      });
    }
  }

  onUnsubscribe() {
    if (!this.listeners.length) {
      var _this$currentMutation;

      (_this$currentMutation = this.currentMutation) == null ? void 0 : _this$currentMutation.removeObserver(this);
    }
  }

  onMutationUpdate(action) {
    this.updateResult(); // Determine which callbacks to trigger

    const notifyOptions = {
      listeners: true
    };

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error') {
      notifyOptions.onError = true;
    }

    this.notify(notifyOptions);
  }

  getCurrentResult() {
    return this.currentResult;
  }

  reset() {
    this.currentMutation = undefined;
    this.updateResult();
    this.notify({
      listeners: true
    });
  }

  mutate(variables, options) {
    this.mutateOptions = options;

    if (this.currentMutation) {
      this.currentMutation.removeObserver(this);
    }

    this.currentMutation = this.client.getMutationCache().build(this.client, { ...this.options,
      variables: typeof variables !== 'undefined' ? variables : this.options.variables
    });
    this.currentMutation.addObserver(this);
    return this.currentMutation.execute();
  }

  updateResult() {
    const state = this.currentMutation ? this.currentMutation.state : (0,mutation/* getDefaultState */.R)();
    const result = { ...state,
      isLoading: state.status === 'loading',
      isSuccess: state.status === 'success',
      isError: state.status === 'error',
      isIdle: state.status === 'idle',
      mutate: this.mutate,
      reset: this.reset
    };
    this.currentResult = result;
  }

  notify(options) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      // First trigger the mutate callbacks
      if (this.mutateOptions) {
        if (options.onSuccess) {
          var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;

          (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null ? void 0 : _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context);
          (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null ? void 0 : _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
        } else if (options.onError) {
          var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;

          (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null ? void 0 : _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
          (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null ? void 0 : _this$mutateOptions$o4.call(_this$mutateOptions4, undefined, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
        }
      } // Then trigger the listeners


      if (options.listeners) {
        this.listeners.forEach(listener => {
          listener(this.currentResult);
        });
      }
    });
  }

}


//# sourceMappingURL=mutationObserver.mjs.map

// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.10.3_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(31781);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.10.3_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/lib/utils.mjs
var lib_utils = __webpack_require__(18462);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.10.3_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/lib/useMutation.mjs






function useMutation(arg1, arg2, arg3) {
  const options = (0,utils/* parseMutationArgs */.lV)(arg1, arg2, arg3);
  const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)({
    context: options.context
  });
  const [observer] = react.useState(() => new MutationObserver(queryClient, options));
  react.useEffect(() => {
    observer.setOptions(options);
  }, [observer, options]);
  const result = (0,useSyncExternalStore/* useSyncExternalStore */.$)(react.useCallback(onStoreChange => observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(onStoreChange)), [observer]), () => observer.getCurrentResult(), () => observer.getCurrentResult());
  const mutate = react.useCallback((variables, mutateOptions) => {
    observer.mutate(variables, mutateOptions).catch(noop);
  }, [observer]);

  if (result.error && (0,lib_utils/* shouldThrowError */.L)(observer.options.useErrorBoundary, [result.error])) {
    throw result.error;
  }

  return { ...result,
    mutate,
    mutateAsync: result.mutate
  };
} // eslint-disable-next-line @typescript-eslint/no-empty-function

function noop() {}


//# sourceMappingURL=useMutation.mjs.map


/***/ }),

/***/ 40505:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KN": function() { return /* binding */ appendErrors; },
/* harmony export */   "U2": function() { return /* binding */ get; },
/* harmony export */   "cI": function() { return /* binding */ useForm; },
/* harmony export */   "t8": function() { return /* binding */ set; }
/* harmony export */ });
/* unused harmony exports Controller, FormProvider, useController, useFieldArray, useFormContext, useFormState, useWatch */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);


var isCheckBoxInput = (element) => element.type === 'checkbox';

var isDateObject = (value) => value instanceof Date;

var isNullOrUndefined = (value) => value == null;

const isObjectType = (value) => typeof value === 'object';
var isObject = (value) => !isNullOrUndefined(value) &&
    !Array.isArray(value) &&
    isObjectType(value) &&
    !isDateObject(value);

var getEventValue = (event) => isObject(event) && event.target
    ? isCheckBoxInput(event.target)
        ? event.target.checked
        : event.target.value
    : event;

var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;

var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));

var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];

var isUndefined = (val) => val === undefined;

var get = (obj, path, defaultValue) => {
    if (!path || !isObject(obj)) {
        return defaultValue;
    }
    const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], obj);
    return isUndefined(result) || result === obj
        ? isUndefined(obj[path])
            ? defaultValue
            : obj[path]
        : result;
};

const EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change',
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all',
};
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate',
};

const HookFormContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const useFormContext = () => React.useContext(HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useFrom methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const FormProvider = (props) => {
    const { children, ...data } = props;
    return (React.createElement(HookFormContext.Provider, { value: data }, children));
};

var getProxyFormState = (formState, control, localProxyFormState, isRoot = true) => {
    const result = {
        defaultValues: control._defaultValues,
    };
    for (const key in formState) {
        Object.defineProperty(result, key, {
            get: () => {
                const _key = key;
                if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
                    control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
                }
                localProxyFormState && (localProxyFormState[_key] = true);
                return formState[_key];
            },
        });
    }
    return result;
};

var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;

var shouldRenderFormState = (formStateData, _proxyFormState, isRoot) => {
    const { name, ...formState } = formStateData;
    return (isEmptyObject(formState) ||
        Object.keys(formState).length >= Object.keys(_proxyFormState).length ||
        Object.keys(formState).find((key) => _proxyFormState[key] ===
            (!isRoot || VALIDATION_MODE.all)));
};

var convertToArrayPayload = (value) => (Array.isArray(value) ? value : [value]);

var shouldSubscribeByName = (name, signalName, exact) => exact && signalName
    ? name === signalName
    : !name ||
        !signalName ||
        name === signalName ||
        convertToArrayPayload(name).some((currentName) => currentName &&
            (currentName.startsWith(signalName) ||
                signalName.startsWith(currentName)));

function useSubscribe(props) {
    const _props = react__WEBPACK_IMPORTED_MODULE_0__.useRef(props);
    _props.current = props;
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        const subscription = !props.disabled &&
            _props.current.subject.subscribe({
                next: _props.current.callback,
            });
        return () => {
            subscription && subscription.unsubscribe();
        };
    }, [props.disabled]);
}

/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFormState(props) {
    const methods = useFormContext();
    const { control = methods.control, disabled, name, exact } = props || {};
    const [formState, updateFormState] = React.useState(control._formState);
    const _mounted = React.useRef(true);
    const _localProxyFormState = React.useRef({
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    });
    const _name = React.useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        callback: React.useCallback((value) => _mounted.current &&
            shouldSubscribeByName(_name.current, value.name, exact) &&
            shouldRenderFormState(value, _localProxyFormState.current) &&
            updateFormState({
                ...control._formState,
                ...value,
            }), [control, exact]),
        subject: control._subjects.state,
    });
    React.useEffect(() => {
        _mounted.current = true;
        const isDirty = control._proxyFormState.isDirty && control._getDirty();
        if (isDirty !== control._formState.isDirty) {
            control._subjects.state.next({
                isDirty,
            });
        }
        control._updateValid();
        return () => {
            _mounted.current = false;
        };
    }, [control]);
    return getProxyFormState(formState, control, _localProxyFormState.current, false);
}

var isString = (value) => typeof value === 'string';

var generateWatchOutput = (names, _names, formValues, isGlobal) => {
    if (isString(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names);
    }
    if (Array.isArray(names)) {
        return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
    }
    isGlobal && (_names.watchAll = true);
    return formValues;
};

var isPlainObject = (tempObject) => {
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return (isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf'));
};

var isWeb = typeof window !== 'undefined' &&
    typeof window.HTMLElement !== 'undefined' &&
    typeof document !== 'undefined';

function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) {
        copy = new Date(data);
    }
    else if (data instanceof Set) {
        copy = new Set(data);
    }
    else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) &&
        (isArray || isObject(data))) {
        copy = isArray ? [] : {};
        if (!Array.isArray(data) && !isPlainObject(data)) {
            copy = data;
        }
        else {
            for (const key in data) {
                copy[key] = cloneObject(data[key]);
            }
        }
    }
    else {
        return data;
    }
    return copy;
}

/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/api/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */
function useWatch(props) {
    const methods = useFormContext();
    const { control = methods.control, name, defaultValue, disabled, exact, } = props || {};
    const _name = React.useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        subject: control._subjects.watch,
        callback: (formState) => {
            if (shouldSubscribeByName(_name.current, formState.name, exact)) {
                const fieldValues = generateWatchOutput(_name.current, control._names, formState.values || control._formValues);
                updateValue(isUndefined(fieldValues) ? defaultValue : cloneObject(fieldValues));
            }
        },
    });
    const [value, updateValue] = React.useState(isUndefined(defaultValue)
        ? control._getWatch(name)
        : defaultValue);
    React.useEffect(() => control._removeUnmounted());
    return value;
}

/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */
function useController(props) {
    const methods = useFormContext();
    const { name, control = methods.control, shouldUnregister } = props;
    const isArrayField = isNameInFieldArray(control._names.array, name);
    const value = useWatch({
        control,
        name,
        defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
        exact: true,
    });
    const formState = useFormState({
        control,
        name,
    });
    const _registerProps = React.useRef(control.register(name, {
        ...props.rules,
        value,
    }));
    React.useEffect(() => {
        const updateMounted = (name, value) => {
            const field = get(control._fields, name);
            if (field) {
                field._f.mount = value;
            }
        };
        updateMounted(name, true);
        return () => {
            const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
            (isArrayField
                ? _shouldUnregisterField && !control._stateFlags.action
                : _shouldUnregisterField)
                ? control.unregister(name)
                : updateMounted(name, false);
        };
    }, [name, control, isArrayField, shouldUnregister]);
    return {
        field: {
            name,
            value,
            onChange: React.useCallback((event) => _registerProps.current.onChange({
                target: {
                    value: getEventValue(event),
                    name: name,
                },
                type: EVENTS.CHANGE,
            }), [name]),
            onBlur: React.useCallback(() => _registerProps.current.onBlur({
                target: {
                    value: get(control._formValues, name),
                    name: name,
                },
                type: EVENTS.BLUR,
            }), [name, control]),
            ref: (elm) => {
                const field = get(control._fields, name);
                if (field && elm) {
                    field._f.ref = {
                        focus: () => elm.focus(),
                        select: () => elm.select(),
                        setCustomValidity: (message) => elm.setCustomValidity(message),
                        reportValidity: () => elm.reportValidity(),
                    };
                }
            },
        },
        formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: () => !!get(formState.errors, name),
            },
            isDirty: {
                enumerable: true,
                get: () => !!get(formState.dirtyFields, name),
            },
            isTouched: {
                enumerable: true,
                get: () => !!get(formState.touchedFields, name),
            },
            error: {
                enumerable: true,
                get: () => get(formState.errors, name),
            },
        }),
    };
}

/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */
const Controller = (props) => props.render(useController(props));

var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria
    ? {
        ...errors[name],
        types: {
            ...(errors[name] && errors[name].types ? errors[name].types : {}),
            [type]: message || true,
        },
    }
    : {};

var isKey = (value) => /^\w*$/.test(value);

var stringToPath = (input) => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));

function set(object, path, value) {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue =
                isObject(objValue) || Array.isArray(objValue)
                    ? objValue
                    : !isNaN(+tempPath[index + 1])
                        ? []
                        : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}

const focusFieldBy = (fields, callback, fieldsNames) => {
    for (const key of fieldsNames || Object.keys(fields)) {
        const field = get(fields, key);
        if (field) {
            const { _f, ...currentField } = field;
            if (_f && callback(_f.name)) {
                if (_f.ref.focus) {
                    _f.ref.focus();
                    break;
                }
                else if (_f.refs && _f.refs[0].focus) {
                    _f.refs[0].focus();
                    break;
                }
            }
            else if (isObject(currentField)) {
                focusFieldBy(currentField, callback);
            }
        }
    }
};

var generateId = () => {
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};

var getFocusFieldName = (name, index, options = {}) => options.shouldFocus || isUndefined(options.shouldFocus)
    ? options.focusName ||
        `${name}.${isUndefined(options.focusIndex) ? index : options.focusIndex}.`
    : '';

var isWatched = (name, _names, isBlurEvent) => !isBlurEvent &&
    (_names.watchAll ||
        _names.watch.has(name) ||
        [..._names.watch].some((watchName) => name.startsWith(watchName) &&
            /^\.\w+/.test(name.slice(watchName.length))));

var updateFieldArrayRootError = (errors, error, name) => {
    const fieldArrayErrors = compact(get(errors, name));
    set(fieldArrayErrors, 'root', error[name]);
    set(errors, name, fieldArrayErrors);
    return errors;
};

var isBoolean = (value) => typeof value === 'boolean';

var isFileInput = (element) => element.type === 'file';

var isFunction = (value) => typeof value === 'function';

var isMessage = (value) => isString(value) || react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(value);

var isRadioInput = (element) => element.type === 'radio';

var isRegex = (value) => value instanceof RegExp;

const defaultResult = {
    value: false,
    isValid: false,
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options
                .filter((option) => option && option.checked && !option.disabled)
                .map((option) => option.value);
            return { value: values, isValid: !!values.length };
        }
        return options[0].checked && !options[0].disabled
            ? // @ts-expect-error expected to work in the browser
                options[0].attributes && !isUndefined(options[0].attributes.value)
                    ? isUndefined(options[0].value) || options[0].value === ''
                        ? validResult
                        : { value: options[0].value, isValid: true }
                    : validResult
            : defaultResult;
    }
    return defaultResult;
};

const defaultReturn = {
    isValid: false,
    value: null,
};
var getRadioValue = (options) => Array.isArray(options)
    ? options.reduce((previous, option) => option && option.checked && !option.disabled
        ? {
            isValid: true,
            value: option.value,
        }
        : previous, defaultReturn)
    : defaultReturn;

function getValidateError(result, ref, type = 'validate') {
    if (isMessage(result) ||
        (Array.isArray(result) && result.every(isMessage)) ||
        (isBoolean(result) && !result)) {
        return {
            type,
            message: isMessage(result) ? result : '',
            ref,
        };
    }
}

var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData)
    ? validationData
    : {
        value: validationData,
        message: '',
    };

var validateField = async (field, inputValue, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled, } = field._f;
    if (!mount || disabled) {
        return {};
    }
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message) => {
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity(isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = ((valueAsNumber || isFileInput(ref)) && !ref.value) ||
        inputValue === '' ||
        (Array.isArray(inputValue) && !inputValue.length);
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message,
            ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message),
        };
    };
    if (isFieldArray
        ? !Array.isArray(inputValue) || !inputValue.length
        : required &&
            ((!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue))) ||
                (isBoolean(inputValue) && !inputValue) ||
                (isCheckBox && !getCheckboxValue(refs).isValid) ||
                (isRadio && !getRadioValue(refs).isValid))) {
        const { value, message } = isMessage(required)
            ? { value: !!required, message: required }
            : getValueAndMessage(required);
        if (value) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.required,
                message,
                ref: inputRef,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber ||
                (inputValue ? +inputValue : inputValue);
            if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
            }
            if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
            }
        }
        else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time) => new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if (isString(maxOutput.value) && inputValue) {
                exceedMax = isTime
                    ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value)
                    : isWeek
                        ? inputValue > maxOutput.value
                        : valueDate > new Date(maxOutput.value);
            }
            if (isString(minOutput.value) && inputValue) {
                exceedMin = isTime
                    ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value)
                    : isWeek
                        ? inputValue < minOutput.value
                        : valueDate < new Date(minOutput.value);
            }
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) &&
        !isEmpty &&
        (isString(inputValue) || (isFieldArray && Array.isArray(inputValue)))) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
            inputValue.length > maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
            inputValue.length < minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.pattern,
                message,
                ref,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction(validate)) {
            const result = await validate(inputValue);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message),
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        }
        else if (isObject(validate)) {
            let validationResult = {};
            for (const key in validate) {
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
                    break;
                }
                const validateError = getValidateError(await validate[key](inputValue), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message),
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) {
                        error[name] = validationResult;
                    }
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult,
                };
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
    }
    setCustomValidity(true);
    return error;
};

function append(data, value) {
    return [...data, ...convertToArrayPayload(value)];
}

var fillEmptyArray = (value) => Array.isArray(value) ? value.map(() => undefined) : undefined;

var getValidationModes = (mode) => ({
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched,
});

function insert(data, index, value) {
    return [
        ...data.slice(0, index),
        ...convertToArrayPayload(value),
        ...data.slice(index),
    ];
}

var moveArrayAt = (data, from, to) => {
    if (!Array.isArray(data)) {
        return [];
    }
    if (isUndefined(data[to])) {
        data[to] = undefined;
    }
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};

function prepend(data, value) {
    return [...convertToArrayPayload(value), ...convertToArrayPayload(data)];
}

function removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [...data];
    for (const index of indexes) {
        temp.splice(index - i, 1);
        i++;
    }
    return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index) => isUndefined(index)
    ? []
    : removeAtIndexes(data, convertToArrayPayload(index).sort((a, b) => a - b));

var swapArrayAt = (data, indexA, indexB) => {
    data[indexA] = [data[indexB], (data[indexB] = data[indexA])][0];
};

function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while (index < length) {
        object = isUndefined(object) ? index++ : object[updatePath[index++]];
    }
    return object;
}
function isEmptyArray(obj) {
    for (const key in obj) {
        if (!isUndefined(obj[key])) {
            return false;
        }
    }
    return true;
}
function unset(object, path) {
    const updatePath = isKey(path) ? [path] : stringToPath(path);
    const childObject = updatePath.length == 1 ? object : baseGet(object, updatePath);
    const key = updatePath[updatePath.length - 1];
    let previousObjRef;
    if (childObject) {
        delete childObject[key];
    }
    for (let k = 0; k < updatePath.slice(0, -1).length; k++) {
        let index = -1;
        let objectRef;
        const currentPaths = updatePath.slice(0, -(k + 1));
        const currentPathsLength = currentPaths.length - 1;
        if (k > 0) {
            previousObjRef = object;
        }
        while (++index < currentPaths.length) {
            const item = currentPaths[index];
            objectRef = objectRef ? objectRef[item] : object[item];
            if (currentPathsLength === index &&
                ((isObject(objectRef) && isEmptyObject(objectRef)) ||
                    (Array.isArray(objectRef) && isEmptyArray(objectRef)))) {
                previousObjRef ? delete previousObjRef[item] : delete object[item];
            }
            previousObjRef = objectRef;
        }
    }
    return object;
}

var updateAt = (fieldValues, index, value) => {
    fieldValues[index] = value;
    return fieldValues;
};

/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFieldArray(props) {
    const methods = useFormContext();
    const { control = methods.control, name, keyName = 'id', shouldUnregister, } = props;
    const [fields, setFields] = React.useState(control._getFieldArray(name));
    const ids = React.useRef(control._getFieldArray(name).map(generateId));
    const _fieldIds = React.useRef(fields);
    const _name = React.useRef(name);
    const _actioned = React.useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules &&
        control.register(name, props.rules);
    const callback = React.useCallback(({ values, name: fieldArrayName, }) => {
        if (fieldArrayName === _name.current || !fieldArrayName) {
            const fieldValues = get(values, _name.current);
            if (Array.isArray(fieldValues)) {
                setFields(fieldValues);
                ids.current = fieldValues.map(generateId);
            }
        }
    }, []);
    useSubscribe({
        callback,
        subject: control._subjects.array,
    });
    const updateValues = React.useCallback((updatedFieldArrayValues) => {
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [control, name]);
    const append$1 = (value, options) => {
        const appendValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = append(control._getFieldArray(name), appendValue);
        control._names.focus = getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = append(ids.current, appendValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, append, {
            argA: fillEmptyArray(value),
        });
    };
    const prepend$1 = (value, options) => {
        const prependValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = prepend(control._getFieldArray(name), prependValue);
        control._names.focus = getFocusFieldName(name, 0, options);
        ids.current = prepend(ids.current, prependValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, prepend, {
            argA: fillEmptyArray(value),
        });
    };
    const remove = (index) => {
        const updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name), index);
        ids.current = removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, removeArrayAt, {
            argA: index,
        });
    };
    const insert$1 = (index, value, options) => {
        const insertValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = getFocusFieldName(name, index, options);
        ids.current = insert(ids.current, index, insertValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, insert, {
            argA: index,
            argB: fillEmptyArray(value),
        });
    };
    const swap = (indexA, indexB) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, swapArrayAt, {
            argA: indexA,
            argB: indexB,
        }, false);
    };
    const move = (from, to) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        moveArrayAt(updatedFieldArrayValues, from, to);
        moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, moveArrayAt, {
            argA: from,
            argB: to,
        }, false);
    };
    const update = (index, value) => {
        const updateValue = cloneObject(value);
        const updatedFieldArrayValues = updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [...updatedFieldArrayValues].map((item, i) => !item || i === index ? generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, updatedFieldArrayValues, updateAt, {
            argA: index,
            argB: updateValue,
        }, true, false);
    };
    const replace = (value) => {
        const updatedFieldArrayValues = convertToArrayPayload(cloneObject(value));
        ids.current = updatedFieldArrayValues.map(generateId);
        updateValues([...updatedFieldArrayValues]);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, [...updatedFieldArrayValues], (data) => data, {}, true, false);
    };
    React.useEffect(() => {
        control._stateFlags.action = false;
        isWatched(name, control._names) && control._subjects.state.next({});
        if (_actioned.current &&
            (!getValidationModes(control._options.mode).isOnSubmit ||
                control._formState.isSubmitted)) {
            if (control._options.resolver) {
                control._executeSchema([name]).then((result) => {
                    const error = get(result.errors, name);
                    const existingError = get(control._formState.errors, name);
                    if (existingError ? !error && existingError.type : error && error.type) {
                        error
                            ? set(control._formState.errors, name, error)
                            : unset(control._formState.errors, name);
                        control._subjects.state.next({
                            errors: control._formState.errors,
                        });
                    }
                });
            }
            else {
                const field = get(control._fields, name);
                if (field && field._f) {
                    validateField(field, get(control._formValues, name), control._options.criteriaMode === VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error) => !isEmptyObject(error) &&
                        control._subjects.state.next({
                            errors: updateFieldArrayRootError(control._formState.errors, error, name),
                        }));
                }
            }
        }
        control._subjects.watch.next({
            name,
            values: control._formValues,
        });
        control._names.focus &&
            focusFieldBy(control._fields, (key) => !!key && key.startsWith(control._names.focus || ''));
        control._names.focus = '';
        control._proxyFormState.isValid && control._updateValid();
    }, [fields, name, control]);
    React.useEffect(() => {
        !get(control._formValues, name) && control._updateFieldArray(name);
        return () => {
            (control._options.shouldUnregister || shouldUnregister) &&
                control.unregister(name);
        };
    }, [name, control, keyName, shouldUnregister]);
    return {
        swap: React.useCallback(swap, [updateValues, name, control]),
        move: React.useCallback(move, [updateValues, name, control]),
        prepend: React.useCallback(prepend$1, [updateValues, name, control]),
        append: React.useCallback(append$1, [updateValues, name, control]),
        remove: React.useCallback(remove, [updateValues, name, control]),
        insert: React.useCallback(insert$1, [updateValues, name, control]),
        update: React.useCallback(update, [updateValues, name, control]),
        replace: React.useCallback(replace, [updateValues, name, control]),
        fields: React.useMemo(() => fields.map((field, index) => ({
            ...field,
            [keyName]: ids.current[index] || generateId(),
        })), [fields, keyName]),
    };
}

function createSubject() {
    let _observers = [];
    const next = (value) => {
        for (const observer of _observers) {
            observer.next(value);
        }
    };
    const subscribe = (observer) => {
        _observers.push(observer);
        return {
            unsubscribe: () => {
                _observers = _observers.filter((o) => o !== observer);
            },
        };
    };
    const unsubscribe = () => {
        _observers = [];
    };
    return {
        get observers() {
            return _observers;
        },
        next,
        subscribe,
        unsubscribe,
    };
}

var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);

function deepEqual(object1, object2) {
    if (isPrimitive(object1) || isPrimitive(object2)) {
        return object1 === object2;
    }
    if (isDateObject(object1) && isDateObject(object2)) {
        return object1.getTime() === object2.getTime();
    }
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        if (!keys2.includes(key)) {
            return false;
        }
        if (key !== 'ref') {
            const val2 = object2[key];
            if ((isDateObject(val1) && isDateObject(val2)) ||
                (isObject(val1) && isObject(val2)) ||
                (Array.isArray(val1) && Array.isArray(val2))
                ? !deepEqual(val1, val2)
                : val1 !== val2) {
                return false;
            }
        }
    }
    return true;
}

var isHTMLElement = (value) => {
    const owner = value ? value.ownerDocument : 0;
    const ElementClass = owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement;
    return value instanceof ElementClass;
};

var isMultipleSelect = (element) => element.type === `select-multiple`;

var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

var live = (ref) => isHTMLElement(ref) && ref.isConnected;

var objectHasFunction = (data) => {
    for (const key in data) {
        if (isFunction(data[key])) {
            return true;
        }
    }
    return false;
};

function markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                fields[key] = Array.isArray(data[key]) ? [] : {};
                markFieldsDirty(data[key], fields[key]);
            }
            else if (!isNullOrUndefined(data[key])) {
                fields[key] = true;
            }
        }
    }
    return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                if (isUndefined(formValues) ||
                    isPrimitive(dirtyFieldsFromValues[key])) {
                    dirtyFieldsFromValues[key] = Array.isArray(data[key])
                        ? markFieldsDirty(data[key], [])
                        : { ...markFieldsDirty(data[key]) };
                }
                else {
                    getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
                }
            }
            else {
                deepEqual(data[key], formValues[key])
                    ? delete dirtyFieldsFromValues[key]
                    : (dirtyFieldsFromValues[key] = true);
            }
        }
    }
    return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));

var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value)
    ? value
    : valueAsNumber
        ? value === ''
            ? NaN
            : value
                ? +value
                : value
        : valueAsDate && isString(value)
            ? new Date(value)
            : setValueAs
                ? setValueAs(value)
                : value;

function getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref) => ref.disabled) : ref.disabled) {
        return;
    }
    if (isFileInput(ref)) {
        return ref.files;
    }
    if (isRadioInput(ref)) {
        return getRadioValue(_f.refs).value;
    }
    if (isMultipleSelect(ref)) {
        return [...ref.selectedOptions].map(({ value }) => value);
    }
    if (isCheckBoxInput(ref)) {
        return getCheckboxValue(_f.refs).value;
    }
    return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}

var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
    const fields = {};
    for (const name of fieldsNames) {
        const field = get(_fields, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [...fieldsNames],
        fields,
        shouldUseNativeValidation,
    };
};

var getRuleValue = (rule) => isUndefined(rule)
    ? rule
    : isRegex(rule)
        ? rule.source
        : isObject(rule)
            ? isRegex(rule.value)
                ? rule.value.source
                : rule.value
            : rule;

var hasValidation = (options) => options.mount &&
    (options.required ||
        options.min ||
        options.max ||
        options.maxLength ||
        options.minLength ||
        options.pattern ||
        options.validate);

function schemaErrorLookup(errors, _fields, name) {
    const error = get(errors, name);
    if (error || isKey(name)) {
        return {
            error,
            name,
        };
    }
    const names = name.split('.');
    while (names.length) {
        const fieldName = names.join('.');
        const field = get(_fields, fieldName);
        const foundError = get(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) {
            return { name };
        }
        if (foundError && foundError.type) {
            return {
                name: fieldName,
                error: foundError,
            };
        }
        names.pop();
    }
    return {
        name,
    };
}

var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
    if (mode.isOnAll) {
        return false;
    }
    else if (!isSubmitted && mode.isOnTouch) {
        return !(isTouched || isBlurEvent);
    }
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
        return !isBlurEvent;
    }
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
        return isBlurEvent;
    }
    return true;
};

var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);

const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true,
};
function createFormControl(props = {}) {
    let _options = {
        ...defaultOptions,
        ...props,
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: {},
    };
    let _fields = {};
    let _defaultValues = cloneObject(_options.defaultValues) || {};
    let _formValues = _options.shouldUnregister
        ? {}
        : cloneObject(_defaultValues);
    let _stateFlags = {
        action: false,
        mount: false,
        watch: false,
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
    };
    let delayErrorCallback;
    let timer = 0;
    let validateFields = {};
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    };
    const _subjects = {
        watch: createSubject(),
        array: createSubject(),
        state: createSubject(),
    };
    const validationModeBeforeSubmit = getValidationModes(_options.mode);
    const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback) => (wait) => {
        clearTimeout(timer);
        timer = window.setTimeout(callback, wait);
    };
    const _updateValid = async () => {
        if (_proxyFormState.isValid) {
            const isValid = _options.resolver
                ? isEmptyObject((await _executeSchema()).errors)
                : (await executeBuiltInValidation(_fields, true)).valid;
            if (isValid !== _formState.isValid) {
                _formState.isValid = isValid;
                _subjects.state.next({
                    isValid,
                });
            }
        }
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
        if (args && method) {
            _stateFlags.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
                const fieldValues = method(get(_fields, name), args.argA, args.argB);
                shouldSetValues && set(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.errors, name))) {
                const errors = method(get(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && set(_formState.errors, name, errors);
                unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields &&
                shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.touchedFields, name))) {
                const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && set(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
            }
            _subjects.state.next({
                name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid,
            });
        }
        else {
            set(_formValues, name, values);
        }
    };
    const updateErrors = (name, error) => {
        set(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
        const field = get(_fields, name);
        if (field) {
            const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
            isUndefined(defaultValue) ||
                (ref && ref.defaultChecked) ||
                shouldSkipSetValueAs
                ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f))
                : setFieldValue(name, defaultValue);
            _stateFlags.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name,
        };
        if (_proxyFormState.isDirty) {
            isPreviousDirty = _formState.isDirty;
            _formState.isDirty = output.isDirty = _getDirty();
            shouldUpdateField = isPreviousDirty !== output.isDirty;
        }
        if (_proxyFormState.dirtyFields && (!isBlurEvent || shouldDirty)) {
            isPreviousDirty = get(_formState.dirtyFields, name);
            const isCurrentFieldPristine = deepEqual(get(_defaultValues, name), fieldValue);
            isCurrentFieldPristine
                ? unset(_formState.dirtyFields, name)
                : set(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField =
                shouldUpdateField || isPreviousDirty !== !isCurrentFieldPristine;
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = get(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                set(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField =
                    shouldUpdateField ||
                        (_proxyFormState.touchedFields &&
                            isPreviousFieldTouched !== isBlurEvent);
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState) => {
        const previousFieldError = get(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid &&
            isBoolean(isValid) &&
            _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(() => updateErrors(name, error));
            delayErrorCallback(props.delayError);
        }
        else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error
                ? set(_formState.errors, name, error)
                : unset(_formState.errors, name);
        }
        if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) ||
            !isEmptyObject(fieldState) ||
            shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...(shouldUpdateValid && isBoolean(isValid) ? { isValid } : {}),
                errors: _formState.errors,
                name,
            };
            _formState = {
                ..._formState,
                ...updatedFormState,
            };
            _subjects.state.next(updatedFormState);
        }
        validateFields[name]--;
        if (_proxyFormState.isValidating &&
            !Object.values(validateFields).some((v) => v)) {
            _subjects.state.next({
                isValidating: false,
            });
            validateFields = {};
        }
    };
    const _executeSchema = async (name) => await _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names) => {
        const { errors } = await _executeSchema();
        if (names) {
            for (const name of names) {
                const error = get(errors, name);
                error
                    ? set(_formState.errors, name, error)
                    : unset(_formState.errors, name);
            }
        }
        else {
            _formState.errors = errors;
        }
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true,
    }) => {
        for (const name in fields) {
            const field = fields[name];
            if (field) {
                const { _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await validateField(field, get(_formValues, _f.name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        if (_f.name === context.name) {
                            context.error = fieldError[context.name];
                        }
                        context.valid = false;
                        if (shouldOnlyCheckValid) {
                            break;
                        }
                    }
                    !shouldOnlyCheckValid &&
                        (get(fieldError, _f.name)
                            ? isFieldArrayRoot
                                ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name)
                                : set(_formState.errors, _f.name, fieldError[_f.name])
                            : unset(_formState.errors, _f.name));
                }
                fieldValue &&
                    (await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context));
            }
        }
        return context;
    };
    const _removeUnmounted = () => {
        for (const name of _names.unMount) {
            const field = get(_fields, name);
            field &&
                (field._f.refs
                    ? field._f.refs.every((ref) => !live(ref))
                    : !live(field._f.ref)) &&
                unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data) => (name && data && set(_formValues, name, data),
        !deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal) => generateWatchOutput(names, _names, {
        ...(_stateFlags.mount
            ? _formValues
            : isUndefined(defaultValue)
                ? _defaultValues
                : isString(names)
                    ? { [names]: defaultValue }
                    : defaultValue),
    }, isGlobal);
    const _getFieldArray = (name) => compact(get(_stateFlags.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
    const setFieldValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        let fieldValue = value;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled &&
                    set(_formValues, name, getFieldValueAs(value, fieldReference));
                fieldValue =
                    isWeb && isHTMLElement(fieldReference.ref) && isNullOrUndefined(value)
                        ? ''
                        : value;
                if (isMultipleSelect(fieldReference.ref)) {
                    [...fieldReference.ref.options].forEach((optionRef) => (optionRef.selected = fieldValue.includes(optionRef.value)));
                }
                else if (fieldReference.refs) {
                    if (isCheckBoxInput(fieldReference.ref)) {
                        fieldReference.refs.length > 1
                            ? fieldReference.refs.forEach((checkboxRef) => (!checkboxRef.defaultChecked || !checkboxRef.disabled) &&
                                (checkboxRef.checked = Array.isArray(fieldValue)
                                    ? !!fieldValue.find((data) => data === checkboxRef.value)
                                    : fieldValue === checkboxRef.value))
                            : fieldReference.refs[0] &&
                                (fieldReference.refs[0].checked = !!fieldValue);
                    }
                    else {
                        fieldReference.refs.forEach((radioRef) => (radioRef.checked = radioRef.value === fieldValue));
                    }
                }
                else if (isFileInput(fieldReference.ref)) {
                    fieldReference.ref.value = '';
                }
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) {
                        _subjects.watch.next({
                            name,
                        });
                    }
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) &&
            updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value, options) => {
        for (const fieldKey in value) {
            const fieldValue = value[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = get(_fields, fieldName);
            (_names.array.has(name) ||
                !isPrimitive(fieldValue) ||
                (field && !field._f)) &&
                !isDateObject(fieldValue)
                ? setValues(fieldName, fieldValue, options)
                : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = cloneObject(value);
        set(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: _formValues,
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) &&
                options.shouldDirty) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
                _subjects.state.next({
                    name,
                    dirtyFields: _formState.dirtyFields,
                    isDirty: _getDirty(name, cloneValue),
                });
            }
        }
        else {
            field && !field._f && !isNullOrUndefined(cloneValue)
                ? setValues(name, cloneValue, options)
                : setFieldValue(name, cloneValue, options);
        }
        isWatched(name, _names) && _subjects.state.next({});
        _subjects.watch.next({
            name,
        });
    };
    const onChange = async (event) => {
        const target = event.target;
        let name = target.name;
        const field = get(_fields, name);
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type
                ? getFieldValue(field._f)
                : getEventValue(event);
            const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            const shouldSkipValidation = (!hasValidation(field._f) &&
                !_options.resolver &&
                !get(_formState.errors, name) &&
                !field._f.deps) ||
                skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = isWatched(name, _names, isBlurEvent);
            set(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            }
            else if (field._f.onChange) {
                field._f.onChange(event);
            }
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent &&
                _subjects.watch.next({
                    name,
                    type: event.type,
                });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return (shouldRender &&
                    _subjects.state.next({ name, ...(watched ? {} : fieldState) }));
            }
            !isBlurEvent && watched && _subjects.state.next({});
            validateFields[name] = validateFields[name]
                ? validateFields[name] + 1
                : 1;
            _subjects.state.next({
                isValidating: true,
            });
            if (_options.resolver) {
                const { errors } = await _executeSchema([name]);
                const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = isEmptyObject(errors);
            }
            else {
                if (_proxyFormState.isValid) {
                    const buildInValidationResult = await executeBuiltInValidation(_fields, true, {
                        name,
                        valid: true,
                    });
                    error = buildInValidationResult.error || {};
                    isValid = buildInValidationResult.valid;
                }
                if (!error || isEmptyObject(error)) {
                    error = (await validateField(field, get(_formValues, name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                }
            }
            field._f.deps &&
                trigger(field._f.deps);
            shouldRenderByError(name, isValid, error, fieldState);
        }
    };
    const trigger = async (name, options = {}) => {
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        _subjects.state.next({
            isValidating: true,
        });
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
            isValid = isEmptyObject(errors);
            validationResult = name
                ? !fieldNames.some((name) => get(errors, name))
                : isValid;
        }
        else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
                const field = get(_fields, fieldName);
                return (await executeBuiltInValidation(field && field._f ? { [fieldName]: field } : field)).valid;
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        }
        else {
            validationResult = isValid = (await executeBuiltInValidation(_fields))
                .valid;
        }
        _subjects.state.next({
            ...(!isString(name) ||
                (_proxyFormState.isValid && isValid !== _formState.isValid)
                ? {}
                : { name }),
            ...(_options.resolver || !name ? { isValid } : {}),
            errors: _formState.errors,
            isValidating: false,
        });
        options.shouldFocus &&
            !validationResult &&
            focusFieldBy(_fields, (key) => key && get(_formState.errors, key), name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames) => {
        const values = {
            ..._defaultValues,
            ...(_stateFlags.mount ? _formValues : {}),
        };
        return isUndefined(fieldNames)
            ? values
            : isString(fieldNames)
                ? get(values, fieldNames)
                : fieldNames.map((name) => get(values, name));
    };
    const getFieldState = (name, formState) => ({
        invalid: !!get((formState || _formState).errors, name),
        isDirty: !!get((formState || _formState).dirtyFields, name),
        isTouched: !!get((formState || _formState).touchedFields, name),
        error: get((formState || _formState).errors, name),
    });
    const clearErrors = (name) => {
        name
            ? convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName))
            : (_formState.errors = {});
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const setError = (name, error, options) => {
        const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
        set(_formState.errors, name, {
            ...error,
            ref,
        });
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false,
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue) => isFunction(name)
        ? _subjects.watch.subscribe({
            next: (payload) => name(_getWatch(undefined, defaultValue), payload),
        })
        : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {}) => {
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (get(_fields, fieldName)) {
                if (!options.keepValue) {
                    unset(_fields, fieldName);
                    unset(_formValues, fieldName);
                }
                !options.keepError && unset(_formState.errors, fieldName);
                !options.keepDirty && unset(_formState.dirtyFields, fieldName);
                !options.keepTouched && unset(_formState.touchedFields, fieldName);
                !_options.shouldUnregister &&
                    !options.keepDefaultValue &&
                    unset(_defaultValues, fieldName);
            }
        }
        _subjects.watch.next({});
        _subjects.state.next({
            ..._formState,
            ...(!options.keepDirty ? {} : { isDirty: _getDirty() }),
        });
        !options.keepIsValid && _updateValid();
    };
    const register = (name, options = {}) => {
        let field = get(_fields, name);
        const disabledIsDefined = isBoolean(options.disabled);
        set(_fields, name, {
            ...(field || {}),
            _f: {
                ...(field && field._f ? field._f : { ref: { name } }),
                name,
                mount: true,
                ...options,
            },
        });
        _names.mount.add(name);
        field
            ? disabledIsDefined &&
                set(_formValues, name, options.disabled
                    ? undefined
                    : get(_formValues, name, getFieldValue(field._f)))
            : updateValidAndValue(name, true, options.value);
        return {
            ...(disabledIsDefined ? { disabled: options.disabled } : {}),
            ...(_options.shouldUseNativeValidation
                ? {
                    required: !!options.required,
                    min: getRuleValue(options.min),
                    max: getRuleValue(options.max),
                    minLength: getRuleValue(options.minLength),
                    maxLength: getRuleValue(options.maxLength),
                    pattern: getRuleValue(options.pattern),
                }
                : {}),
            name,
            onChange,
            onBlur: onChange,
            ref: (ref) => {
                if (ref) {
                    register(name, options);
                    field = get(_fields, name);
                    const fieldRef = isUndefined(ref.value)
                        ? ref.querySelectorAll
                            ? ref.querySelectorAll('input,select,textarea')[0] || ref
                            : ref
                        : ref;
                    const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox
                        ? refs.find((option) => option === fieldRef)
                        : fieldRef === field._f.ref) {
                        return;
                    }
                    set(_fields, name, {
                        _f: {
                            ...field._f,
                            ...(radioOrCheckbox
                                ? {
                                    refs: [
                                        ...refs.filter(live),
                                        fieldRef,
                                        ...(Array.isArray(get(_defaultValues, name)) ? [{}] : []),
                                    ],
                                    ref: { type: fieldRef.type, name },
                                }
                                : { ref: fieldRef }),
                        },
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                }
                else {
                    field = get(_fields, name, {});
                    if (field._f) {
                        field._f.mount = false;
                    }
                    (_options.shouldUnregister || options.shouldUnregister) &&
                        !(isNameInFieldArray(_names.array, name) && _stateFlags.action) &&
                        _names.unMount.add(name);
                }
            },
        };
    };
    const _focusError = () => _options.shouldFocusError &&
        focusFieldBy(_fields, (key) => key && get(_formState.errors, key), _names.mount);
    const handleSubmit = (onValid, onInvalid) => async (e) => {
        if (e) {
            e.preventDefault && e.preventDefault();
            e.persist && e.persist();
        }
        let hasNoPromiseError = true;
        let fieldValues = cloneObject(_formValues);
        _subjects.state.next({
            isSubmitting: true,
        });
        try {
            if (_options.resolver) {
                const { errors, values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            }
            else {
                await executeBuiltInValidation(_fields);
            }
            if (isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {},
                    isSubmitting: true,
                });
                await onValid(fieldValues, e);
            }
            else {
                if (onInvalid) {
                    await onInvalid({ ..._formState.errors }, e);
                }
                _focusError();
            }
        }
        catch (err) {
            hasNoPromiseError = false;
            throw err;
        }
        finally {
            _formState.isSubmitted = true;
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: isEmptyObject(_formState.errors) && hasNoPromiseError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors,
            });
        }
    };
    const resetField = (name, options = {}) => {
        if (get(_fields, name)) {
            if (isUndefined(options.defaultValue)) {
                setValue(name, get(_defaultValues, name));
            }
            else {
                setValue(name, options.defaultValue);
                set(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) {
                unset(_formState.touchedFields, name);
            }
            if (!options.keepDirty) {
                unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue
                    ? _getDirty(name, get(_defaultValues, name))
                    : _getDirty();
            }
            if (!options.keepError) {
                unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({ ..._formState });
        }
    };
    const _reset = (formValues, keepStateOptions = {}) => {
        const updatedValues = formValues || _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const values = formValues && !isEmptyObject(formValues)
            ? cloneUpdatedValues
            : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) {
            _defaultValues = updatedValues;
        }
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                for (const fieldName of _names.mount) {
                    get(_formState.dirtyFields, fieldName)
                        ? set(values, fieldName, get(_formValues, fieldName))
                        : setValue(fieldName, get(values, fieldName));
                }
            }
            else {
                if (isWeb && isUndefined(formValues)) {
                    for (const name of _names.mount) {
                        const field = get(_fields, name);
                        if (field && field._f) {
                            const fieldReference = Array.isArray(field._f.refs)
                                ? field._f.refs[0]
                                : field._f.ref;
                            if (isHTMLElement(fieldReference)) {
                                const form = fieldReference.closest('form');
                                if (form) {
                                    form.reset();
                                    break;
                                }
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister
                ? keepStateOptions.keepDefaultValues
                    ? cloneObject(_defaultValues)
                    : {}
                : cloneUpdatedValues;
            _subjects.array.next({
                values,
            });
            _subjects.watch.next({
                values,
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: '',
        };
        _stateFlags.mount =
            !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _stateFlags.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount
                ? _formState.submitCount
                : 0,
            isDirty: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues
                ? _formState.isDirty
                : !!(keepStateOptions.keepDefaultValues &&
                    !deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted
                ? _formState.isSubmitted
                : false,
            dirtyFields: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues
                ? _formState.dirtyFields
                : keepStateOptions.keepDefaultValues && formValues
                    ? getDirtyFields(_defaultValues, formValues)
                    : {},
            touchedFields: keepStateOptions.keepTouched
                ? _formState.touchedFields
                : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitting: false,
            isSubmitSuccessful: false,
        });
    };
    const reset = (formValues, keepStateOptions) => _reset(isFunction(formValues)
        ? formValues(_formValues)
        : formValues, keepStateOptions);
    const setFocus = (name, options = {}) => {
        const field = get(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs
                ? fieldReference.refs[0]
                : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    return {
        control: {
            register,
            unregister,
            getFieldState,
            _executeSchema,
            _focusError,
            _getWatch,
            _getDirty,
            _updateValid,
            _removeUnmounted,
            _updateFieldArray,
            _getFieldArray,
            _subjects,
            _proxyFormState,
            get _fields() {
                return _fields;
            },
            get _formValues() {
                return _formValues;
            },
            get _stateFlags() {
                return _stateFlags;
            },
            set _stateFlags(value) {
                _stateFlags = value;
            },
            get _defaultValues() {
                return _defaultValues;
            },
            get _names() {
                return _names;
            },
            set _names(value) {
                _names = value;
            },
            get _formState() {
                return _formState;
            },
            set _formState(value) {
                _formState = value;
            },
            get _options() {
                return _options;
            },
            set _options(value) {
                _options = {
                    ..._options,
                    ...value,
                };
            },
        },
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        resetField,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState,
    };
}

/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useForm(props = {}) {
    const _formControl = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
    const [formState, updateFormState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
        isDirty: false,
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: {},
        defaultValues: props.defaultValues,
    });
    if (!_formControl.current) {
        _formControl.current = {
            ...createFormControl(props),
            formState,
        };
    }
    const control = _formControl.current.control;
    control._options = props;
    useSubscribe({
        subject: control._subjects.state,
        callback: react__WEBPACK_IMPORTED_MODULE_0__.useCallback((value) => {
            if (shouldRenderFormState(value, control._proxyFormState, true)) {
                control._formState = {
                    ...control._formState,
                    ...value,
                };
                updateFormState({ ...control._formState });
            }
        }, [control]),
    });
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (!control._stateFlags.mount) {
            control._proxyFormState.isValid && control._updateValid();
            control._stateFlags.mount = true;
        }
        if (control._stateFlags.watch) {
            control._stateFlags.watch = false;
            control._subjects.state.next({});
        }
        control._removeUnmounted();
    });
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        formState.submitCount && control._focusError();
    }, [control, formState.submitCount]);
    _formControl.current.formState = getProxyFormState(formState, control);
    return _formControl.current;
}


//# sourceMappingURL=index.esm.mjs.map


/***/ })

}]);